!function o(r, i, s) {
    function a(t, e) {
        if (!i[t]) {
            if (!r[t]) {
                var n = "function" == typeof require && undefined;
                if (!e && n) return n(t, !0);
                if (c) return c(t, !0);
                throw (n = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", n;
            }
            n = i[t] = {
                exports: {}
            }, r[t][0].call(n.exports, function(e) {
                return a(r[t][1][e] || e);
            }, n, n.exports, o, r, i, s);
        }
        return i[t].exports;
    }
    for(var c = "function" == typeof require && undefined, e = 0; e < s.length; e++)a(s[e]);
    return a;
}({
    1: [
        function(e, t, n) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.default = function(e, s) {
                var a = [
                    "a",
                    "b",
                    "x",
                    "y",
                    "lb",
                    "rb",
                    "lt",
                    "rt",
                    "back",
                    "start",
                    "N/A",
                    "N/A",
                    "up",
                    "down",
                    "left",
                    "right"
                ], r = {
                    left: 37,
                    right: 39,
                    up: 38,
                    down: 40,
                    lsleft: 37,
                    lsright: 39,
                    lsup: 38,
                    lsdown: 40,
                    rsleft: 37,
                    rsright: 39,
                    rsup: 38,
                    rsdown: 40
                }, c = e.getKeyEventConsumer(), u = [], l = {};
                function f(e, t, n) {
                    t.keymap;
                    var o = t.keymap[e];
                    (o = !o && t.mapArrows ? r[e] : o) && -1 === n.indexOf(o) && n.push(o);
                }
                function d(e, t, n, o, r) {
                    var i = o.stickThreshold;
                    i && (i < e && f(n + "right", o, r), e < -i && f(n + "left", o, r), i < t && f(n + "down", o, r), t < -i && f(n + "up", o, r));
                }
                function t() {
                    for(var e, t = navigator.getGamepads(), n = 0; n < t.length; n++){
                        var o = t[n];
                        if (o && o.connected) {
                            for(var o = function(e, t) {
                                for(var n = t.buttons || a, o = [], r = 0; r < n.length; r++)e.buttons[r] && e.buttons[r].pressed && f(n[r], t, o);
                                return d(e.axes[0], e.axes[1], "ls", t, o), d(e.axes[2], e.axes[3], "rs", t, o), o;
                            }(o, (e = n, o = void 0, -1 === (o = u.indexOf(e)) && (o = u.length, u.push(e)), o = Math.min(o, s.gamepads.length - 1), s.gamepads[o])), r = function(e, t) {
                                var n = [], o = [];
                                t = t || [];
                                for(var r = 0; r < t.length; r++)-1 === e.indexOf(t[r]) && n.push(t[r]);
                                for(r = 0; r < e.length; r++)-1 === t.indexOf(e[r]) && o.push(e[r]);
                                return {
                                    press: o,
                                    release: n
                                };
                            }(o, l[n]), i = 0; i < r.press.length; i++)c.onPress(r.press[i]);
                            for(i = 0; i < r.release.length; i++)c.onRelease(r.release[i]);
                            l[n] = o;
                        }
                    }
                }
                s.scanEvery && setInterval(t, s.scanEvery), s.scanOnTick && e.dos.registerTickListener(t);
            };
        },
        {}
    ],
    2: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.keys.js"), Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var o = {
                keysCode: {
                    left: 37,
                    right: 39,
                    up: 38,
                    down: 40
                }
            };
            n.default = function(e, i, t) {
                function r(e, t, n) {
                    l[e] = {
                        x: t,
                        y: n
                    };
                }
                function s(e, t, n) {
                    var o, r;
                    void 0 !== l[e] && (o = l[e].x - t, r = l[e].y - n, Math.abs(o) < 15 && Math.abs(r) < 15 || (r = Math.abs(o) >= Math.abs(r) ? o < 0 ? "right" : "left" : r < 0 ? "down" : "up", l[e].x = t, l[e].y = n, function(e, t) {
                        if (u[e] !== t) {
                            u[e] = t;
                            for(var n = 0, o = Object.keys(u); n < o.length; n++){
                                var r = o[n];
                                r !== e && "down" === u[r] && (u[r] = "up", i.onRelease(c[r]));
                            }
                            "down" === t && i.onPress(c[e]);
                        }
                    }(r, "down"), delete l[e]));
                }
                function a(e, t, n) {
                    s(e, t, n), delete l[e];
                }
                var c = (t = void 0 === t ? o : t).keysCode, u = {
                    left: "up",
                    right: "up",
                    up: "up",
                    down: "up"
                }, l = {};
                e.addEventListener("touchstart", function(e) {
                    e.preventDefault();
                    for(var t = e.changedTouches, n = 0; n < t.length; n++){
                        var o = t[n];
                        r(o.identifier, o.pageX, o.pageY);
                    }
                }, !0), e.addEventListener("touchmove", function(e) {
                    e.preventDefault();
                    for(var t = e.changedTouches, n = 0; n < t.length; n++){
                        var o = t[n];
                        s(o.identifier, o.pageX, o.pageY);
                    }
                }, !0), e.addEventListener("touchend", function(e) {
                    e.preventDefault();
                    for(var t = e.changedTouches, n = 0; n < t.length; n++){
                        var o = t[n];
                        a(o.identifier, o.pageX, o.pageY);
                    }
                }, !0), e.addEventListener("mousedown", function(e) {
                    e.preventDefault(), r(-1, e.pageX, e.pageY);
                }, !0), e.addEventListener("mousemove", function(e) {
                    e.preventDefault(), s(-1, e.pageX, e.pageY);
                }, !0), e.addEventListener("mouseup", function(e) {
                    e.preventDefault(), a(-1, e.pageX, e.pageY);
                }, !0), e.addEventListener("mouseleave", function(e) {
                    e.preventDefault(), a(-1, e.pageX, e.pageY);
                }, !0);
            };
        },
        {
            "core-js/modules/es6.object.keys.js": 122
        }
    ],
    3: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.array.find-index.js"), e("core-js/modules/es6.function.name.js");
            var o = Object.create ? function(e, t, n, o) {
                void 0 === o && (o = n), Object.defineProperty(e, o, {
                    enumerable: !0,
                    get: function() {
                        return t[n];
                    }
                });
            } : function(e, t, n, o) {
                e[o = void 0 === o ? n : o] = t[n];
            }, r = Object.create ? function(e, t) {
                Object.defineProperty(e, "default", {
                    enumerable: !0,
                    value: t
                });
            } : function(e, t) {
                e.default = t;
            }, i = function(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)"default" !== n && Object.hasOwnProperty.call(e, n) && o(t, e, n);
                return r(t, e), t;
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var c = i(e("../js-dos-dom")), u = {
                uppercase: !0
            };
            n.default = function(e, r, i) {
                function t() {
                    var e, t, n, o = i.uppercase ? a.value.toUpperCase() : a.value;
                    a.value = "", a.blur(), s.style.visibility = "hidden", 0 !== o.length && (e = 0, t = function(t) {
                        for(var e, n = [
                            {
                                name: "Backspace",
                                code: 8
                            },
                            {
                                name: "Tab",
                                code: 9
                            },
                            {
                                name: "Enter",
                                code: 13
                            },
                            {
                                name: "Shift",
                                code: 16
                            },
                            {
                                name: "Ctrl",
                                code: 17
                            },
                            {
                                name: "Alt",
                                code: 18
                            },
                            {
                                name: "Pause",
                                code: 19
                            },
                            {
                                name: "Caps",
                                code: 20
                            },
                            {
                                name: "Esc",
                                code: 27
                            },
                            {
                                name: "PgUp",
                                code: 33
                            },
                            {
                                name: "PgDn",
                                code: 34
                            },
                            {
                                name: "End",
                                code: 35
                            },
                            {
                                name: "Home",
                                code: 36
                            },
                            {
                                name: "Left",
                                code: 37
                            },
                            {
                                name: "Up",
                                code: 38
                            },
                            {
                                name: "Right",
                                code: 39
                            },
                            {
                                name: "Down",
                                code: 40
                            },
                            {
                                name: "Insert",
                                code: 45
                            },
                            {
                                name: "Delete",
                                code: 46
                            }
                        ], o = 0, r = ""; o < t.length;)"<" === t[o] && -1 !== (e = n.findIndex(function(e) {
                            return t.substr(o + 1, e.name.length + 1).toLowerCase() === e.name.toLowerCase() + ">";
                        })) ? (r += String.fromCharCode(n[e].code), o += n[e].name.length + 2) : (r += t[o], o++);
                        return r;
                    }(o), n = setInterval(function() {
                        e >= 2 * t.length ? clearInterval(n) : (e % 2 == 0 ? r.onPress(t.charCodeAt(e / 2)) : r.onRelease(t.charCodeAt((e - 1) / 2)), e++);
                    }, 100));
                }
                c.applyCss("lqwerty-css", l + "\n\n" + ((i = void 0 === i ? u : i).cssText || ""));
                var s = c.createDiv("qwerty-container");
                s.innerHTML = '\n        <div>ENTER CHARS:</div>\n\n        <div class="qwerty-input-row">\n            <div>:>&nbsp;</div>\n            <input class="qwerty-input" value="">\n            \x3c!-- <div class="qwerty-cursor"></div> --\x3e\n            <div class="qwerty-send">Send</div>\n        </div>\n    ', s.style.visibility = "hidden";
                var n = function(e) {
                    e.stopPropagation();
                };
                function o() {
                    a.style.width = Math.max(2, a.value.length + 1) + "ch";
                }
                s.addEventListener("keydown", n), s.addEventListener("keyup", n), s.addEventListener("keypress", function(e) {
                    13 === e.keyCode && t();
                }), s.addEventListener("keypress", n);
                var a = s.getElementsByTagName("input")[0];
                a.tabIndex = 1, a.addEventListener("input", o), a.addEventListener("blur", t), n = s.getElementsByClassName("qwerty-send")[0], c.addButtonListener(n, function() {}, t), n = c.createDiv("qwerty-key"), c.addButtonListener(n, function() {}, function() {
                    "hidden" === s.style.visibility ? (o(), s.style.visibility = "visible", a.focus()) : s.style.visibility = "hidden";
                }), e.appendChild(n), e.appendChild(s);
            };
            var l = "\n    .qwerty-container {\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n\n        display: flex;\n        flex-direction: column;\n\n        padding: 10px 20px;\n\n        font-size: 1em;\n        background: #000000e3;\n        border-bottom: 2px solid white;\n        font-family: monospace;\n        color: white;\n\n        line-height: 1.4em;\n    }\n\n    .qwerty-input-row {\n        display: flex;\n        flex-grow: 1;\n        align-items: center;\n    }\n\n    .qwerty-input, .qwerty-input:focus {\n        padding: 0;\n        margin: 0;\n        border: none;\n        background: black;\n        color: white;\n        font: inherit;\n        display: inline-block;\n        outline: none;\n    }\n\n    .qwerty-send {\n        color: black;\n        padding: 5px 0.5em;\n        margin-left: 0.5em;\n\n        padding: 5px;\n        background: lightgray;\n        border-left: 1px solid white;\n        border-top: 1px solid white;\n        border-right: 1px solid darkgray;\n        border-bottom: 1px solid darkgray;\n    }\n\n    .qwerty-key {\n        display: flex;\n        position: absolute;\n        left: 10px;\n        bottom: 10px;\n\n        align-items: center;\n        justify-content: center;\n        color: black;\n        font-size: 2em;\n\n        width: 48px;\n        height: 48px;\n        background: lightgray url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAZRJREFUWIXtlr9KA0EQxn9ngmBroY0W/k0stZbYKFqICD6DYCFiLfgIgtG8iGIkRcBGsLGx8Q+JYAhcwDdQE8/iZsncesgpeCuYDw72+2bmZnZ3bhLooYf/Dg8YBIYc5X/2gDcg66iAtgcEjpID3Z0vAo2Uc08AFVNAA6inXEAWoM8SN4ASsKm0omg54QXhe8pnX7R54TPCi8pnS7R1u5IAmJR1SfiZZQ+AFeG7wu+VT120beGrKs6gIvxQeB4I7O6/AcrAldJOgQzQUsnKRHumKgU9CvfFp23vNg76BH4TsSdg90DqsAs4ont3AdBRtnPRDoRPK78xK/5Exb2LtpykgK+4WWdibLaWUTYvLrE2BsAUYXPl6O4GwiaqynoWGCZstBowACyI7QJ4UfEtwoYGWLIKMvF54A7Sa0IbsZ9hAZgjPA0zC3b4fDVJ0QGOZb0GjAPXwKV2SjqIfvoYJBpEPvBAdMjcEr3D70APoid5t287Oe0B54PIfIZN4DXl3P3AqPN/RB7h7/OIo/xNR3l7+EP4AJe/eBF8vW9QAAAAAElFTkSuQmCC) no-repeat center center;\n        border-left: 1px solid white;\n        border-top: 1px solid white;\n        border-right: 1px solid darkgray;\n        border-bottom: 1px solid darkgray;\n    }\n\n    .qwerty-cursor {\n        background: white;\n        width: 0.5em;\n        height: 1em;\n        animation: qwerty-blink 1s;\n        -moz-animation: qwerty-blink 1s infinite;\n        -webkit-animation: qwerty-blink 1s infinite;\n    }\n\n    @-moz-keyframes qwerty-blink {\n        0% {background:white;}\n        50% {background:black;}\n        100% {background:white;}\n    }\n\n    @-webkit-keyframes qwerty-blink {\n        0% {background:white;}\n        50% {background:black;}\n        100% {background:white;}\n    }\n";
        },
        {
            "../js-dos-dom": 10,
            "core-js/modules/es6.array.find-index.js": 114,
            "core-js/modules/es6.function.name.js": 116
        }
    ],
    4: [
        function(e, t, n) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.Build = void 0, n.Build = {
                version: "6.22.60 (c3627d34f97fcc6e98ceef7fbea6e090)",
                jsVersion: "7e48530baf07daa1d82796f9c209647378a1030a",
                wasmJsSize: 189751,
                wasmVersion: "df90df0fd894cf6ee026bf847969c3ce",
                wasmSize: 1808397,
                jsSize: 6657376,
                buildSeed: 1622012539860
            };
        },
        {}
    ],
    5: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.to-string.js"), e("core-js/modules/es6.regexp.to-string.js"), Object.defineProperty(n, "__esModule", {
                value: !0
            });
            o.prototype.put = function(e, t, n) {
                var o;
                null !== this.db ? ((o = this.db.transaction(this.storeName, "readwrite")).oncomplete = function() {
                    return n();
                }, o.objectStore(this.storeName).put(t, e)) : n();
            }, o.prototype.get = function(e, t, n) {
                var o;
                null !== this.db ? ((o = this.db.transaction(this.storeName, "readonly").objectStore(this.storeName).get(e)).onerror = function() {
                    return n("Can't read value for key '" + e + "'");
                }, o.onsuccess = function() {
                    o.result ? t(o.result) : n("Result is empty for key '" + e + "', result: " + o.result);
                }) : n("db is not initalized");
            }, o.prototype.forEach = function(t, n) {
                var e;
                null !== this.db ? ((e = this.db.transaction(this.storeName, "readonly").objectStore(this.storeName).openCursor()).onerror = function() {
                    return n();
                }, e.onsuccess = function(e) {
                    e = e.target.result;
                    e ? (t(e.key.toString(), e.value), e.continue()) : n();
                }) : n();
            }, e = o;
            function o(e, t, n) {
                var o, r = this;
                this.storeName = "files", this.db = null, this.version = e, this.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB, this.indexedDB ? ((o = this.indexedDB.open("js-dos-cache (" + e + ")", 1)).onerror = function(e) {
                    n("Can't open cache database");
                }, o.onsuccess = function(e) {
                    r.db = o.result, t(r);
                }, o.onupgradeneeded = function(e) {
                    try {
                        r.db = o.result, r.db.onerror = function(e) {
                            n("Can't upgrade cache database");
                        }, r.db.createObjectStore(r.storeName);
                    } catch (e) {
                        n("Can't upgrade cache database");
                    }
                }) : n("Indexed db is not supported on this host");
            }
            n.default = e;
        },
        {
            "core-js/modules/es6.object.to-string.js": 123,
            "core-js/modules/es6.regexp.to-string.js": 130
        }
    ],
    6: [
        function(e, t, n) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var o = (r.prototype.put = function(e, t, n) {}, r.prototype.get = function(e, t, n) {
                n("Cache is not supported on this host");
            }, r.prototype.forEach = function(e, t) {
                t();
            }, r);
            function r() {}
            n.default = o;
        },
        {}
    ],
    7: [
        function(e, t, n) {
            "use strict";
            var o = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var r = o(e("./js-dos-cache-db")), i = o(e("./js-dos-cache-noop"));
            n.default = function(t, n) {
                new r.default(t.version, n, function(e) {
                    void 0 !== t.log && t.log("ERR! Can't initalize cache, cause: " + e), n(new i.default);
                });
            };
        },
        {
            "./js-dos-cache-db": 5,
            "./js-dos-cache-noop": 6
        }
    ],
    8: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.to-string.js"), e("core-js/modules/es6.promise.js"), Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.DosCommandInterface = void 0;
            o.prototype.width = function() {
                return this.dos.canvas.width;
            }, o.prototype.height = function() {
                return this.dos.canvas.height;
            }, o.prototype.fullscreen = function() {
                function e(e) {
                    e.requestFullscreen ? e.requestFullscreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.msRequestFullscreen ? e.msRequestFullscreen() : e.webkitEnterFullscreen ? e.webkitEnterFullscreen() : (t.fullscreenInitialCssStyle = e.style.cssText, e.style.cssText = "\n                    position: fixed;\n                    left: 0;\n                    top: 0;\n                    bottom: 0;\n                    right: 0;\n                    background: black;\n                    z-index: 999;\n                ");
                }
                var t = this, n = this.getParentDiv();
                null !== n && "dosbox-container" === n.className ? e(n) : e(this.dos.canvas);
            }, o.prototype.exitFullscreen = function() {
                function e(e) {
                    void 0 !== t.fullscreenInitialCssStyle ? (e.style.cssText = t.fullscreenInitialCssStyle, delete t.fullscreenInitialCssStyle) : document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.webkitExitFullscreen ? document.mozCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen();
                }
                var t = this, n = this.getParentDiv();
                null !== n && "dosbox-container" === n.className ? e(n) : e(this.dos.canvas);
            }, o.prototype.listenStdout = function(e) {
                this.onstdout = e;
            }, o.prototype.shell = function() {
                for(var i = this, s = [], e = 0; e < arguments.length; e++)s[e] = arguments[e];
                if (0 !== s.length) return new Promise(function(e, t) {
                    i.shellInputClients.push(e);
                    for(var n = 0, o = s; n < o.length; n++){
                        var r = o[n];
                        i.shellInputQueue.push(r);
                    }
                    i.requestShellInput();
                });
            }, o.prototype.screenshot = function() {
                var e = this;
                return new Promise(function(t) {
                    e.api.send("screenshot", "", function(e) {
                        t(e);
                    });
                });
            }, o.prototype.exit = function() {
                try {
                    this.dos.terminate(), this.api.send("exit");
                } catch (e) {
                    return 0;
                }
                return this.dos.error("Runtime is still alive!"), -1;
            }, o.prototype.simulateKeyEvent = function(e, t) {
                var n = t ? "keydown" : "keyup", o = document.createEvent("KeyboardEvent"), t = {
                    get: function() {
                        return this.keyCodeVal;
                    }
                };
                Object.defineProperty(o, "keyCode", t), Object.defineProperty(o, "which", t), Object.defineProperty(o, "charCode", t), o.initKeyboardEvent ? o.initKeyboardEvent(n, !0, !0, document.defaultView, !1, !1, !1, !1, e, e) : o.initKeyEvent(n, !0, !0, document.defaultView, !1, !1, !1, !1, e, 0), o.keyCodeVal = e, this.dos.canvas && this.dos.canvas.dispatchEvent(o);
            }, o.prototype.simulateKeyPress = function(e) {
                var t = this;
                this.simulateKeyEvent(e, !0), setTimeout(function() {
                    return t.simulateKeyEvent(e, !1);
                }, 100);
            }, o.prototype.getParentDiv = function() {
                return this.dos.canvas.parentElement instanceof HTMLDivElement ? this.dos.canvas.parentElement : null;
            }, o.prototype.getKeyEventConsumer = function() {
                return this.keyEventConsumer;
            }, o.prototype.sendKeyPress = function(e) {
                this.api.send("sdl_key_event", e + "");
            }, o.prototype.requestShellInput = function() {
                this.sendKeyPress(13);
            }, o.prototype.onping = function(e, t) {
                switch(e){
                    case "ready":
                        this.onready(this);
                        break;
                    case "frame":
                        this.onframe();
                        break;
                    case "shell_input":
                        if (0 === this.shellInputQueue.length) return;
                        var n = t[0], o = t[1], r = this.shellInputQueue.shift(), i = this.em.lengthBytesUTF8(r) + 1;
                        if (o < i) return void (void 0 !== this.dos.onerror && this.dos.onerror("Can't execute cmd '" + r + "', because it's bigger then max cmd length " + o));
                        if (this.em.stringToUTF8(r, n, i), 0 === this.shellInputQueue.length) {
                            for(var s = 0, a = this.shellInputClients; s < a.length; s++)(0, a[s])();
                            this.shellInputClients = [];
                        } else this.requestShellInput();
                        break;
                    case "write_stdout":
                        i = t[0];
                        this.onstdout && this.onstdout(i);
                }
            }, o.prototype.onframe = function() {
                this.dos.tick();
            }, e = o;
            function o(e, t) {
                var o = this;
                this.shellInputQueue = [], this.shellInputClients = [], this.onstdout = void 0, this.keyEventConsumer = {
                    onPress: function(e) {
                        return o.simulateKeyEvent(e, !0);
                    },
                    onRelease: function(e) {
                        return o.simulateKeyEvent(e, !1);
                    }
                }, this.dos = e, this.em = e, this.api = e, this.api.ping = function(e) {
                    for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                    o.onping(e, t);
                }, this.onready = t;
            }
            n.DosCommandInterface = e;
        },
        {
            "core-js/modules/es6.object.to-string.js": 123,
            "core-js/modules/es6.promise.js": 124
        }
    ],
    9: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.regexp.replace.js"), e("core-js/modules/es6.object.keys.js"), Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var o = e("./js-dos-options");
            n.default = function(t) {
                var n = r;
                return Object.keys(o.DosBoxConfigDefaults).forEach(function(e) {
                    e, n = n.replace("%" + e + "%", (t[e] || o.DosBoxConfigDefaults[e]) + "");
                }), n;
            };
            var r = "\n# This is the configurationfile for DOSBox 0.74. (Please use the latest version of DOSBox)\n# Lines starting with a # are commentlines and are ignored by DOSBox.\n# They are used to (briefly) document the effect of each option.\n\n[sdl]\n#       fullscreen: Start dosbox directly in fullscreen. (Press ALT-Enter to go back)\n#       fulldouble: Use double buffering in fullscreen. It can reduce screen flickering, but it can also result in a slow DOSBox.\n#   fullresolution: What resolution to use for fullscreen: original or fixed size (e.g. 1024x768).\n#                     Using your monitor's native resolution with aspect=true might give the best results.\n#                     If you end up with small window on a large screen, try an output different from surface.\n# windowresolution: Scale the window to this size IF the output device supports hardware scaling.\n#                     (output=surface does not!)\n#           output: What video system to use for output.\n#                   Possible values: surface, overlay, opengl, openglnb.\n#         autolock: Mouse will automatically lock, if you click on the screen. (Press CTRL-F10 to unlock)\n#      sensitivity: Mouse sensitivity.\n#      waitonerror: Wait before closing the console if dosbox has an error.\n#         priority: Priority levels for dosbox. Second entry behind the comma is for when dosbox is not focused/minimized.\n#                     pause is only valid for the second entry.\n#                   Possible values: lowest, lower, normal, higher, highest, pause.\n#       mapperfile: File used to load/save the key/event mappings from. Resetmapper only works with the defaul value.\n#     usescancodes: Avoid usage of symkeys, might not work on all operating systems.\n\nfullscreen=false\nfulldouble=false\nfullresolution=original\nwindowresolution=original\noutput=surface\nautolock=%autolock%\nsensitivity=100\nwaitonerror=true\npriority=higher,normal\nmapperfile=mapper-jsdos.map\nusescancodes=true\nvsync=false\n\n[dosbox]\n# language: Select another language file.\n#  machine: The type of machine tries to emulate.\n#           Possible values: hercules, cga, tandy, pcjr, ega, vgaonly, svga_s3, svga_et3000, svga_et4000, svga_paradise, vesa_nolfb, vesa_oldvbe.\n# captures: Directory where things like wave, midi, screenshot get captured.\n#  memsize: Amount of memory DOSBox has in megabytes.\n#             This value is best left at its default to avoid problems with some games,\n#             though few games might require a higher value.\n#             There is generally no speed advantage when raising this value.\n\nlanguage=\nmachine=svga_s3\ncaptures=capture\nmemsize=16\n\n[render]\n# frameskip: How many frames DOSBox skips before drawing one.\n#    aspect: Do aspect correction, if your output method doesn't support scaling this can slow things down!.\n#    scaler: Scaler used to enlarge/enhance low resolution modes.\n#              If 'forced' is appended, then the scaler will be used even if the result might not be desired.\n#            Possible values: none, normal2x, normal3x, advmame2x, advmame3x, advinterp2x, advinterp3x, hq2x, hq3x, 2xsai, super2xsai, supereagle, tv2x, tv3x, rgb2x, rgb3x, scan2x, scan3x.\n\nframeskip=0\naspect=false\nscaler=none\n\n[cpu]\n#      core: CPU Core used in emulation. auto will switch to dynamic if available and appropriate.\n#            Possible values: auto, dynamic, normal, simple.\n#   cputype: CPU Type used in emulation. auto is the fastest choice.\n#            Possible values: auto, 386, 386_slow, 486_slow, pentium_slow, 386_prefetch.\n#    cycles: Amount of instructions DOSBox tries to emulate each millisecond.\n#            Setting this value too high results in sound dropouts and lags.\n#            Cycles can be set in 3 ways:\n#              'auto'          tries to guess what a game needs.\n#                              It usually works, but can fail for certain games.\n#              'fixed #number' will set a fixed amount of cycles. This is what you usually need if 'auto' fails.\n#                              (Example: fixed 4000).\n#              'max'           will allocate as much cycles as your computer is able to handle.\n#\n#            Possible values: auto, fixed, max.\n#   cycleup: Amount of cycles to decrease/increase with keycombo.(CTRL-F11/CTRL-F12)\n# cycledown: Setting it lower than 100 will be a percentage.\n\ncore=auto\ncputype=auto\ncycles=%cycles%\ncycleup=10\ncycledown=20\n\n[mixer]\n#   nosound: Enable silent mode, sound is still emulated though.\n#      rate: Mixer sample rate, setting any device's rate higher than this will probably lower their sound quality.\n#            Possible values: 44100, 48000, 32000, 22050, 16000, 11025, 8000, 49716.\n# blocksize: Mixer block size, larger blocks might help sound stuttering but sound will also be more lagged.\n#            Possible values: 1024, 2048, 4096, 8192, 512, 256.\n# prebuffer: How many milliseconds of data to keep on top of the blocksize.\n\nnosound=false\nrate=44100\nblocksize=1024\nprebuffer=20\n\n[midi]\n#     mpu401: Type of MPU-401 to emulate.\n#             Possible values: intelligent, uart, none.\n# mididevice: Device that will receive the MIDI data from MPU-401.\n#             Possible values: default, win32, alsa, oss, coreaudio, coremidi, none.\n# midiconfig: Special configuration options for the device driver. This is usually the id of the device you want to use.\n#               See the README/Manual for more details.\n\nmpu401=intelligent\nmididevice=default\nmidiconfig=\n\n[sblaster]\n#  sbtype: Type of Soundblaster to emulate. gb is Gameblaster.\n#          Possible values: sb1, sb2, sbpro1, sbpro2, sb16, gb, none.\n#  sbbase: The IO address of the soundblaster.\n#          Possible values: 220, 240, 260, 280, 2a0, 2c0, 2e0, 300.\n#     irq: The IRQ number of the soundblaster.\n#          Possible values: 7, 5, 3, 9, 10, 11, 12.\n#     dma: The DMA number of the soundblaster.\n#          Possible values: 1, 5, 0, 3, 6, 7.\n#    hdma: The High DMA number of the soundblaster.\n#          Possible values: 1, 5, 0, 3, 6, 7.\n# sbmixer: Allow the soundblaster mixer to modify the DOSBox mixer.\n# oplmode: Type of OPL emulation. On 'auto' the mode is determined by sblaster type. All OPL modes are Adlib-compatible, except for 'cms'.\n#          Possible values: auto, cms, opl2, dualopl2, opl3, none.\n#  oplemu: Provider for the OPL emulation. compat might provide better quality (see oplrate as well).\n#          Possible values: default, compat, fast.\n# oplrate: Sample rate of OPL music emulation. Use 49716 for highest quality (set the mixer rate accordingly).\n#          Possible values: 44100, 49716, 48000, 32000, 22050, 16000, 11025, 8000.\n\nsbtype=sb16\nsbbase=220\nirq=7\ndma=1\nhdma=5\nsbmixer=true\noplmode=auto\noplemu=default\noplrate=44100\n\n[gus]\n#      gus: Enable the Gravis Ultrasound emulation.\n#  gusrate: Sample rate of Ultrasound emulation.\n#           Possible values: 44100, 48000, 32000, 22050, 16000, 11025, 8000, 49716.\n#  gusbase: The IO base address of the Gravis Ultrasound.\n#           Possible values: 240, 220, 260, 280, 2a0, 2c0, 2e0, 300.\n#   gusirq: The IRQ number of the Gravis Ultrasound.\n#           Possible values: 5, 3, 7, 9, 10, 11, 12.\n#   gusdma: The DMA channel of the Gravis Ultrasound.\n#           Possible values: 3, 0, 1, 5, 6, 7.\n# ultradir: Path to Ultrasound directory. In this directory\n#           there should be a MIDI directory that contains\n#           the patch files for GUS playback. Patch sets used\n#           with Timidity should work fine.\n\ngus=false\ngusrate=44100\ngusbase=240\ngusirq=5\ngusdma=3\nultradir=C:ULTRASND\n\n[speaker]\n# pcspeaker: Enable PC-Speaker emulation.\n#    pcrate: Sample rate of the PC-Speaker sound generation.\n#            Possible values: 44100, 48000, 32000, 22050, 16000, 11025, 8000, 49716.\n#     tandy: Enable Tandy Sound System emulation. For 'auto', emulation is present only if machine is set to 'tandy'.\n#            Possible values: auto, on, off.\n# tandyrate: Sample rate of the Tandy 3-Voice generation.\n#            Possible values: 44100, 48000, 32000, 22050, 16000, 11025, 8000, 49716.\n#    disney: Enable Disney Sound Source emulation. (Covox Voice Master and Speech Thing compatible).\n\npcspeaker=true\npcrate=44100\ntandy=auto\ntandyrate=44100\ndisney=true\n\n[joystick]\n# joysticktype: Type of joystick to emulate: auto (default), none,\n#               2axis (supports two joysticks),\n#               4axis (supports one joystick, first joystick used),\n#               4axis_2 (supports one joystick, second joystick used),\n#               fcs (Thrustmaster), ch (CH Flightstick).\n#               none disables joystick emulation.\n#               auto chooses emulation depending on real joystick(s).\n#               (Remember to reset dosbox's mapperfile if you saved it earlier)\n#               Possible values: auto, 2axis, 4axis, 4axis_2, fcs, ch, none.\n#        timed: enable timed intervals for axis. Experiment with this option, if your joystick drifts (away).\n#     autofire: continuously fires as long as you keep the button pressed.\n#       swap34: swap the 3rd and the 4th axis. can be useful for certain joysticks.\n#   buttonwrap: enable button wrapping at the number of emulated buttons.\n\njoysticktype=auto\ntimed=true\nautofire=false\nswap34=false\nbuttonwrap=false\n\n[serial]\n# serial1: set type of device connected to com port.\n#          Can be disabled, dummy, modem, nullmodem, directserial.\n#          Additional parameters must be in the same line in the form of\n#          parameter:value. Parameter for all types is irq (optional).\n#          for directserial: realport (required), rxdelay (optional).\n#                           (realport:COM1 realport:ttyS0).\n#          for modem: listenport (optional).\n#          for nullmodem: server, rxdelay, txdelay, telnet, usedtr,\n#                         transparent, port, inhsocket (all optional).\n#          Example: serial1=modem listenport:5000\n#          Possible values: dummy, disabled, modem, nullmodem, directserial.\n# serial2: see serial1\n#          Possible values: dummy, disabled, modem, nullmodem, directserial.\n# serial3: see serial1\n#          Possible values: dummy, disabled, modem, nullmodem, directserial.\n# serial4: see serial1\n#          Possible values: dummy, disabled, modem, nullmodem, directserial.\n\nserial1=dummy\nserial2=dummy\nserial3=disabled\nserial4=disabled\n\n[dos]\n#            xms: Enable XMS support.\n#            ems: Enable EMS support.\n#            umb: Enable UMB support.\n# keyboardlayout: Language code of the keyboard layout (or none).\n\nxms=true\nems=true\numb=true\nkeyboardlayout=auto\n\n[ipx]\n# ipx: Enable ipx over UDP/IP emulation.\n\nipx=false\n\n[autoexec]\n# Lines in this section will be run at startup.\n# You can put your MOUNT lines here.\n\n# https://js-dos.com\n# \u2588\u2580\u2580\u2580\u2580\u2580\u2588 \u2588  \u2584\u2584\u2584\u2580\u2580\u2588 \u2588\u2580\u2580\u2580\u2580\u2580\u2588\n# \u2588 \u2588\u2588\u2588 \u2588 \u2588\u2588\u2584 \u2588 \u2580 \u2584 \u2588 \u2588\u2588\u2588 \u2588\n# \u2588 \u2580\u2580\u2580 \u2588 \u2584\u2588\u2588 \u2580 \u2580\u2580\u2588 \u2588 \u2580\u2580\u2580 \u2588\n# \u2580\u2580\u2580\u2580\u2580\u2580\u2580 \u2580 \u2588\u2584\u2580\u2584\u2580 \u2588 \u2580\u2580\u2580\u2580\u2580\u2580\u2580\n# \u2588\u2580\u2584\u2584\u2588\u2580\u2580\u2584\u2584 \u2580 \u2580\u2588\u2584\u2584\u2584\u2584 \u2580\u2584\u2588\u2580\u2588\u2580\n# \u2588\u2580 \u2580 \u2580\u2580\u2584 \u2588\u2580 \u2584 \u2584\u2580\u2580\u2580\u2584 \u2588\u2580\u2588\u2584\n# \u2584 \u2584\u2584 \u2588\u2580\u2580\u2584 \u2584\u2580\u2584\u2580\u2580\u2588  \u2580\u2580\u2584\u2580\u2580\u2588\u2580\n#   \u2584\u2580\u2580\u2588\u2580\u2580 \u2588\u2580\u2588\u2580\u2588\u2580\u2580\u2584 \u2580\u2588\u2588\u2580\u2588\u2584\n# \u2580\u2580\u2580 \u2580 \u2580 \u2588\u2584\u2588 \u2580\u2588\u2584\u2584\u2588\u2580\u2580\u2580\u2588\u2580\u2580\n# \u2588\u2580\u2580\u2580\u2580\u2580\u2588 \u2584\u2584\u2584 \u2584 \u2584 \u2588 \u2580 \u2588\u2584\u2584\u2584\u2584\n# \u2588 \u2588\u2588\u2588 \u2588 \u2580\u2588\u2580\u2580\u2584\u2580\u2580\u2584\u2588\u2588\u2588\u2588\u2580\u2580\u2588\u2584\u2588\n# \u2588 \u2580\u2580\u2580 \u2588 \u2584\u2580\u2580\u2588\u2580\u2588\u2580\u2584 \u2580\u2580\u2584\u2584\u2588\u2584\u2588\n# \u2580\u2580\u2580\u2580\u2580\u2580\u2580 \u2580   \u2580\u2580 \u2580  \u2580   \u2580\u2580\u2580\n";
        },
        {
            "./js-dos-options": 14,
            "core-js/modules/es6.object.keys.js": 122,
            "core-js/modules/es6.regexp.replace.js": 128
        }
    ],
    10: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.keys.js"), Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.addButtonListener = n.createDiv = n.applyCss = void 0;
            var o = "ontouchstart" in document.documentElement;
            function r(e, t) {
                var n;
                null === document.getElementById(e) && ((n = document.createElement("style")).id = e, n.innerHTML = t, document.head.appendChild(n));
            }
            n.applyCss = r, n.createDiv = function(e, t) {
                var n = document.createElement("div");
                return void 0 !== e && (n.className = e), void 0 !== t && r(e + "-style", t), n;
            }, n.addButtonListener = function(r, i, s) {
                var a, e, c = !1;
                o && (a = {}, r.addEventListener("touchmove", e = function(e) {
                    if (e.target === r) for(var t = e.changedTouches, n = 0; n < t.length; n++){
                        var o = t[n].identifier;
                        switch(e.type){
                            case "touchstart":
                                0 === Object.keys(a).length && i(), a[o] = 1;
                                break;
                            case "touchend":
                                delete a[o], 0 === Object.keys(a).length && s();
                                break;
                            default:
                                return;
                        }
                        c = 0 < Object.keys(a).length, e.preventDefault();
                    }
                }, !0), r.addEventListener("touchstart", e, !0), r.addEventListener("touchend", e, !0));
                var t = !1;
                r.addEventListener("mousedown", function(e) {
                    c || 0 !== e.button || e.target !== r || (t = !0, i(), e.preventDefault());
                }, !0), r.addEventListener("mouseup", function(e) {
                    !c && t && 0 === e.button && (t = !1, s(), e.preventDefault());
                }, !0), r.addEventListener("mouseleave", function(e) {
                    !c && t && 0 === e.button && (t = !1, s());
                }, !0);
            };
        },
        {
            "core-js/modules/es6.object.keys.js": 122
        }
    ],
    11: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.to-string.js"), e("core-js/modules/es6.promise.js"), e("core-js/modules/es6.typed.uint8-array.js"), e("core-js/modules/es6.regexp.split.js"), e("core-js/modules/es6.string.iterator.js"), e("core-js/modules/es6.array.iterator.js"), e("core-js/modules/web.dom.iterable.js"), e("core-js/modules/es6.regexp.replace.js"), e("core-js/modules/es6.regexp.constructor.js"), e("core-js/modules/es6.object.keys.js"), e("core-js/modules/es6.string.ends-with.js");
            var o = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.DosFS = void 0;
            var a = o(e("./js-dos-cache-noop")), u = e("./js-dos-xhr"), e = (c.prototype.chdir = function(e) {
                this.fs.chdir(e);
            }, c.prototype.extract = function(e, t, n) {
                return this.extractAll([
                    {
                        url: e,
                        mountPoint: t = void 0 === t ? "/" : t,
                        type: n = void 0 === n ? "zip" : n
                    }
                ]);
            }, c.prototype.extractAll = function(o) {
                function r(t) {
                    var n = c.normalizePath(t.mountPoint), o = t.type || "zip", s = "/" === n || 0 === n.length, e = n.split("/");
                    return c.createPath(e, 0, e.length), s || c.fs.mount(c.fs.filesystems.IDBFS, {}, n), function() {
                        var r, i, e;
                        return s || !c.readOk(n) ? (s || c.dos.warn("Indexed db does not contains '" + n + "' rewriting..."), r = t.url, i = n, e = o, new Promise(function(n, o) {
                            "zip" === e ? new u.Xhr(r, {
                                cache: new a.default,
                                responseType: "arraybuffer",
                                fail: function(e) {
                                    return o(e);
                                },
                                progress: function(e, t) {
                                    void 0 !== c.dos.onprogress && c.dos.onprogress("Downloading " + r, e, t);
                                },
                                success: function(e) {
                                    c.chdir(i);
                                    var t = new Uint8Array(e), e = c.em._malloc(t.length);
                                    c.em.HEAPU8.set(t, e);
                                    t = c.em._extract_zip(e, t.length);
                                    c.em._free(e), 0 === t ? (c.writeOk(i), n()) : o("Can't extract zip, retcode " + t + ", see more info in logs");
                                }
                            }) : o("Only ZIP archive is supported");
                        })) : Promise.resolve();
                    };
                }
                var c = this;
                return new Promise(function(i, s) {
                    if (0 < c.lastSyncTime) s("Can't create persistent mount point, after syncing process starts");
                    else {
                        for(var a = [], e = 0, t = o; e < t.length; e++){
                            var n = t[e];
                            a.push(r(n));
                        }
                        c.fs.syncfs(!0, function(e) {
                            e && c.dos.error("Can't restore FS from indexed db, cause: " + e);
                            for(var t = [], n = 0, o = a; n < o.length; n++){
                                var r = o[n];
                                t.push(r());
                            }
                            Promise.all(t).then(function() {
                                c.syncFs().then(i).catch(s);
                            }).catch(s);
                        });
                    }
                });
            }, c.prototype.createFile = function(e, t) {
                t instanceof ArrayBuffer && (t = new Uint8Array(t));
                var n, o = (e = e.replace(new RegExp("^[a-zA-z]+:"), "").replace(new RegExp("\\\\", "g"), "/")).split("/");
                0 !== o.length ? 0 !== (n = o[o.length - 1].trim()).length ? (o = this.createPath(o, 0, o.length - 1), this.fs.createDataFile(o, n, t, !0, !0, !0)) : void 0 !== this.dos.onerror && this.dos.onerror("Can't create file '" + e + "', because file name is empty") : void 0 !== this.dos.onerror && this.dos.onerror("Can't create file '" + e + "', because it's not valid file path");
            }, c.prototype.writeFsToFile = function(r, i, t) {
                this.fs.syncfs(!1, function(e) {
                    e || (window.indexedDB.open(t).onsuccess = function(e) {
                        var e = e.target.result, o = {};
                        e.transaction([
                            "FILE_DATA"
                        ], "readonly").objectStore("FILE_DATA").openCursor().onsuccess = function(e) {
                            var t, n = e.target.result;
                            n ? (i && !i.test(n.key) || ((t = n.value).contents = c.toBase64(t.contents), e = n.key, o[e] = t), n.continue()) : c.saveToFile(r, JSON.stringify(o));
                        };
                    });
                });
            }, c.prototype.readFsFromFile = function(e) {
                var t, s = this;
                e && ((t = new FileReader).onload = function(e) {
                    if (e.target) for(var e = e.target.result, t = JSON.parse(e), n = 0, o = Object.keys(t); n < o.length; n++){
                        var r = o[n], i = t[r], i = c.fromBase64(i.contents);
                        s.fs.analyzePath(r).exists && s.fs.unlink(r), s.createFile(r, i);
                    }
                }, t.readAsText(e));
            }, c.toBase64 = function(e) {
                for(var t = "", n = e.byteLength, o = 0; o < n; o++)t += String.fromCharCode(e[o]);
                return window.btoa(t);
            }, c.fromBase64 = function(e) {
                for(var t = window.atob(e), n = t.length, o = new Uint8Array(n), r = 0; r < n; r++)o[r] = t.charCodeAt(r);
                return o;
            }, c.saveToFile = function(e, t) {
                var n = new Blob([
                    t
                ], {
                    type: "text/csv"
                }), t = window.document.createElement("a");
                t.href = window.URL.createObjectURL(n), t.download = e, document.body.appendChild(t), t.click(), document.body.removeChild(t);
            }, c.prototype.createPath = function(e, t, n) {
                for(var o = "", r = t; r < n; ++r){
                    var i = e[r].trim();
                    0 !== i.length && (this.fs.createPath(o, i, !0, !0), o = o + "/" + i);
                }
                return o;
            }, c.prototype.syncFs = function() {
                var o = this;
                return this.syncingPromise || (this.syncingPromise = new Promise(function(t, n) {
                    Date.now();
                    o.fs.syncfs(!1, function(e) {
                        e && (o.dos.error("Can't sync FS to indexed db, cause: " + e), n(e)), o.syncingPromise = null, o.lastSyncTime = Date.now(), t();
                    });
                }), this.syncingPromise);
            }, c.prototype.normalizePath = function(e) {
                return e = 1 < (e = 0 === e.length || "/" !== e[0] ? "/" + e : e).length && e.endsWith("/") ? e.substr(0, e.length - 1) : e;
            }, c.prototype.readOk = function(e) {
                try {
                    var t = this.fs.readFile(e + "/state.fs");
                    return 79 === t[0] && 70 === t[1];
                } catch (e) {
                    return !1;
                }
            }, c.prototype.writeOk = function(e) {
                this.createFile(e + "/state.fs", new Uint8Array([
                    79,
                    70
                ]));
            }, c);
            function c(e) {
                var t = this;
                this.syncingPromise = null, this.lastSyncTime = 0, this.dos = e, this.em = e, this.fs = e.FS, this.dos.registerTickListener(function() {
                    Date.now() - t.lastSyncTime < 5e3 || (t.lastSyncTime = Date.now(), t.syncFs());
                }), this.dos.registerPauseListener(function() {
                    return t.syncFs();
                }), this.dos.registerTerminateListener(function() {
                    return t.syncFs();
                });
            }
            n.DosFS = e;
        },
        {
            "./js-dos-cache-noop": 6,
            "./js-dos-xhr": 16,
            "core-js/modules/es6.array.iterator.js": 115,
            "core-js/modules/es6.object.keys.js": 122,
            "core-js/modules/es6.object.to-string.js": 123,
            "core-js/modules/es6.promise.js": 124,
            "core-js/modules/es6.regexp.constructor.js": 125,
            "core-js/modules/es6.regexp.replace.js": 128,
            "core-js/modules/es6.regexp.split.js": 129,
            "core-js/modules/es6.string.ends-with.js": 131,
            "core-js/modules/es6.string.iterator.js": 132,
            "core-js/modules/es6.typed.uint8-array.js": 134,
            "core-js/modules/web.dom.iterable.js": 135
        }
    ],
    12: [
        function(e, t, n) {
            "use strict";
            function o(e) {
                return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            e("core-js/modules/es6.typed.uint8-array.js"), e("core-js/modules/es6.math.imul.js"), e("core-js/modules/es6.math.fround.js"), e("core-js/modules/es6.math.clz32.js"), e("core-js/modules/es6.math.trunc.js"), e("core-js/modules/es6.string.ends-with.js"), e("core-js/modules/es6.regexp.replace.js"), e("core-js/modules/es6.object.to-string.js"), e("core-js/modules/es6.promise.js"), e("core-js/modules/es6.symbol.js"), e("core-js/modules/es6.string.iterator.js"), e("core-js/modules/es6.array.iterator.js"), e("core-js/modules/web.dom.iterable.js"), Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.Host = void 0;
            var l = e("./js-dos-build"), f = e("./js-dos-xhr"), e = (r.prototype.polyfill = function() {
                Math.imul && -5 === Math.imul(4294967295, 5) || (Math.imul = function(e, t) {
                    var n = 65535 & e, o = 65535 & t;
                    return n * o + ((e >>> 16) * o + n * (t >>> 16) << 16) | 0;
                }), Math.imul = Math.imul, Math.fround || (Math.fround = function(e) {
                    return e;
                }), Math.fround = Math.fround, Math.clz32 || (Math.clz32 = function(e) {
                    e >>>= 0;
                    for(var t = 0; t < 32; t++)if (e & 1 << 31 - t) return t;
                    return 32;
                }), Math.clz32 = Math.clz32, Math.trunc || (Math.trunc = function(e) {
                    return e < 0 ? Math.ceil(e) : Math.floor(e);
                }), Math.trunc = Math.trunc;
            }, r.prototype.resolveDosBox = function(e, t, n) {
                var o = this;
                this.global.exports.WDOSBOX ? n.ondosbox(this.global.exports.WDOSBOX, this.global.exports.instantiateWasm) : (null === this.wdosboxPromise && (this.wdosboxPromise = this.compileDosBox(e, t, n)), this.wdosboxPromise.then(function(e) {
                    setTimeout(function() {
                        o.wdosboxPromise = null, n.ondosbox(o.global.exports.WDOSBOX, o.global.exports.instantiateWasm);
                    }, 1);
                }, function(e) {
                    setTimeout(function() {
                        o.wdosboxPromise = null, void 0 !== n.onerror && n.onerror(e);
                    }, 1);
                }));
            }, r.prototype.compileDosBox = function(e, t, n) {
                var o = e.lastIndexOf("/"), r = e.indexOf("w", o), o = r === o + 1 && 0 <= r;
                return this.wasmSupported && o ? this.compileWasmDosBox(e, t, n) : (n.log && (n.log("[WARN] Using js version of dosbox, perfomance can be lower then expected"), n.log("[DEBUG] Wasm supported: " + this.wasmSupported + ", url: " + e)), o && (e = e.substr(0, r) + e.substr(r + 1)).endsWith("dosbox.js") && (e = e.replace("dosbox.js", "dosbox-emterp.js")), this.compileJsDosBox(e, t, n));
            }, r.prototype.compileJsDosBox = function(r, e, i) {
                var s = this;
                return new Promise(function(t, o) {
                    var n = l.Build.jsSize;
                    r.replace(".js", ".js.mem");
                    new f.Xhr(r, {
                        cache: e,
                        progress: function(e, t) {
                            i.onprogress && i.onprogress("Resolving DosBox (" + r + ")", n, Math.min(n, t));
                        },
                        fail: function(e, t, n) {
                            o("Can't download dosbox.js, code: " + t + ", message: " + n + ", url: " + e);
                        },
                        success: function(e) {
                            void 0 !== i.onprogress && i.onprogress("Resolving DosBox (" + r + ")", n, n), e += eval.call(s, e), t(s.global.exports.WDOSBOX);
                        }
                    });
                });
            }, r.prototype.compileWasmDosBox = function(s, a, c) {
                var u = this;
                return new Promise(function(t, r) {
                    var i = l.Build.wasmSize + l.Build.wasmJsSize, e = s.replace(".js", ".wasm.js");
                    new f.Xhr(e, {
                        cache: a,
                        responseType: "arraybuffer",
                        progress: function(e, t) {
                            c.onprogress && c.onprogress("Resolving DosBox (" + s + ")", i, Math.min(l.Build.wasmSize, t));
                        },
                        fail: function(e, t, n) {
                            r("Can't download wasm, code: " + t + ", message: " + n + ", url: " + e);
                        },
                        success: function(e) {
                            function o(e) {
                                r(e + "");
                            }
                            e = WebAssembly.compile(e);
                            e.catch(o), e.then(function(n) {
                                u.global.exports.instantiateWasm = function(e, t) {
                                    return e.env.globalscall = function() {
                                        for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                                        c.onglobals && c.onglobals.apply(null, e);
                                    }, WebAssembly.instantiate(n, e).catch(o).then(function(e) {
                                        t(e, n);
                                    });
                                }, new f.Xhr(s, {
                                    cache: a,
                                    progress: function(e, t) {
                                        c.onprogress && c.onprogress("Resolving DosBox", i, Math.min(i, l.Build.wasmSize + t));
                                    },
                                    fail: function(e, t, n) {
                                        r("Can't download wdosbox.js, code: " + t + ", message: " + n + ", url: " + e);
                                    },
                                    success: function(e) {
                                        void 0 !== c.onprogress && c.onprogress("Resolving DosBox", i, i), e += eval.call(window, e), t(u.global.exports.WDOSBOX);
                                    }
                                });
                            });
                        }
                    });
                });
            }, r);
            function r() {
                this.wasmSupported = !1, this.global = window, this.wdosboxPromise = null, this.global.exports = {};
                try {
                    var e;
                    "object" !== ("undefined" == typeof WebAssembly ? "undefined" : o(WebAssembly)) || "function" != typeof WebAssembly.instantiate || "function" != typeof WebAssembly.compile || (e = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0))) instanceof WebAssembly.Module && (this.wasmSupported = new WebAssembly.Instance(e) instanceof WebAssembly.Instance);
                } catch (e) {}
                this.polyfill();
            }
            n.Host = new e;
        },
        {
            "./js-dos-build": 4,
            "./js-dos-xhr": 16,
            "core-js/modules/es6.array.iterator.js": 115,
            "core-js/modules/es6.math.clz32.js": 117,
            "core-js/modules/es6.math.fround.js": 118,
            "core-js/modules/es6.math.imul.js": 119,
            "core-js/modules/es6.math.trunc.js": 120,
            "core-js/modules/es6.object.to-string.js": 123,
            "core-js/modules/es6.promise.js": 124,
            "core-js/modules/es6.regexp.replace.js": 128,
            "core-js/modules/es6.string.ends-with.js": 131,
            "core-js/modules/es6.string.iterator.js": 132,
            "core-js/modules/es6.symbol.js": 133,
            "core-js/modules/es6.typed.uint8-array.js": 134,
            "core-js/modules/web.dom.iterable.js": 135
        }
    ],
    13: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.to-string.js"), e("core-js/modules/es6.promise.js");
            var o, r = (o = function(e, t) {
                return (o = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var n in t)t.hasOwnProperty(n) && (e[n] = t[n]);
                })(e, t);
            }, function(e, t) {
                function n() {
                    this.constructor = e;
                }
                o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
            }), i = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.DosModule = void 0;
            var s, a = e("./js-dos-build"), c = e("./js-dos-ci"), u = i(e("./js-dos-conf")), l = e("./js-dos-fs"), i = e("./js-dos-options"), f = e("./js-dos-ui"), r = (s = i.DosOptions, r(d, s), d.prototype.registerDefaultListeners = function() {
                var e, t = this;
                void 0 !== document.hidden ? e = "hidden" : void 0 !== document.mozHidden ? e = "mozHidden" : void 0 !== document.msHidden ? e = "msHidden" : void 0 !== document.webkitHidden && (e = "webkitHidden"), document.addEventListener("visibilityChange", function() {
                    document[e] ? t.pause() : t.resume();
                }, !1), window.addEventListener("beforeunload", function() {
                    t.terminate();
                });
            }, d.prototype.debug = function(e) {
                void 0 !== this.log && this.log("[DEBUG] " + e);
            }, d.prototype.info = function(e) {
                void 0 !== this.log && this.log("[INFO] " + e);
            }, d.prototype.warn = function(e) {
                void 0 !== this.log && this.log("[WARN] " + e);
            }, d.prototype.error = function(e) {
                void 0 !== this.log && this.log("[ERROR] " + e);
            }, d.prototype.ondosbox = function(e, t) {
                this.info("DosBox resolved"), this.instantiateWasm = t, this.instance = new e(this);
            }, d.prototype.resolve = function() {
                var o = this;
                this.wdosboxUrl || (this.wdosboxUrl = "wdosbox.js"), this.log || (this.log = function(e) {
                    return console.log(e);
                }), this.canvas ? (this.onprogress || (this.ui = new f.DosUi(this), this.onprogress = function(e, t, n) {
                    null !== o.ui && o.ui.onprogress(e, t, n);
                }), this.SDL = {
                    defaults: {
                        widht: 320,
                        height: 200,
                        copyOnLock: !1,
                        discardOnLock: !0,
                        opaqueFrontBuffer: !1
                    }
                }, this.isValid = !0) : void 0 !== this.onerror && this.onerror("canvas field is required, but not set!");
            }, d.prototype.onRuntimeInitialized = function() {
                var t = this;
                this.fs = new l.DosFS(this), this.onready({
                    fs: this.fs,
                    main: function(e) {
                        return null !== t.ui && (t.ui.detach(), t.ui = null), e = e || [], null === t.fs ? new Promise(function(e, t) {
                            t("IllegalState: fs is null");
                        }) : (t.fs.chdir("/"), t.fs.createFile("/home/web_user/.dosbox/dosbox-jsdos.conf", u.default(t)), e.unshift("-userconf", "-c", "mount c .", "-c", "c:"), new c.DosCommandInterface(t, function(e) {
                            t.ciResolveFn(e);
                        }), t.callMain(e), t.ci);
                    }
                });
            }, d.prototype.registerTickListener = function(e) {
                this.tickListeners.push(e);
            }, d.prototype.registerPauseListener = function(e) {
                this.pauseListeners.push(e);
            }, d.prototype.registerResumeListener = function(e) {
                this.resumeListeners.push(e);
            }, d.prototype.registerTerminateListener = function(e) {
                this.terminateListeners.push(e);
            }, d.prototype.tick = function() {
                for(var e = 0, t = this.tickListeners; e < t.length; e++)(0, t[e])();
            }, d.prototype.pause = function() {
                for(var e = 0, t = this.pauseListeners; e < t.length; e++)(0, t[e])();
            }, d.prototype.resume = function() {
                for(var e = 0, t = this.resumeListeners; e < t.length; e++)(0, t[e])();
            }, d.prototype.terminate = function() {
                for(var e = 0, t = this.terminateListeners; e < t.length; e++)(0, t[e])();
            }, d);
            function d(e, t) {
                var n = s.call(this) || this;
                return n.isValid = !1, n.version = a.Build.version, n.fs = null, n.ui = null, n.tickListeners = [], n.pauseListeners = [], n.resumeListeners = [], n.terminateListeners = [], n.ciResolveFn = function() {}, n.canvas = e, n.onready = t, n.ci = new Promise(function(e) {
                    n.ciResolveFn = e;
                }), n.registerDefaultListeners(), n;
            }
            n.DosModule = r;
        },
        {
            "./js-dos-build": 4,
            "./js-dos-ci": 8,
            "./js-dos-conf": 9,
            "./js-dos-fs": 11,
            "./js-dos-options": 14,
            "./js-dos-ui": 15,
            "core-js/modules/es6.object.to-string.js": 123,
            "core-js/modules/es6.promise.js": 124
        }
    ],
    14: [
        function(e, t, n) {
            "use strict";
            var o, r = (o = function(e, t) {
                return (o = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var n in t)t.hasOwnProperty(n) && (e[n] = t[n]);
                })(e, t);
            }, function(e, t) {
                function n() {
                    this.constructor = e;
                }
                o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
            });
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.DosBoxConfigDefaults = n.DosOptions = n.DosBoxConfig = void 0;
            var i = function() {};
            n.DosBoxConfig = i;
            var s, i = (r(a, s = i), a);
            function a() {
                return null !== s && s.apply(this, arguments) || this;
            }
            n.DosOptions = i, n.DosBoxConfigDefaults = {
                cycles: "max",
                autolock: !1
            };
        },
        {}
    ],
    15: [
        function(e, t, n) {
            "use strict";
            var o = Object.create ? function(e, t, n, o) {
                void 0 === o && (o = n), Object.defineProperty(e, o, {
                    enumerable: !0,
                    get: function() {
                        return t[n];
                    }
                });
            } : function(e, t, n, o) {
                e[o = void 0 === o ? n : o] = t[n];
            }, r = Object.create ? function(e, t) {
                Object.defineProperty(e, "default", {
                    enumerable: !0,
                    value: t
                });
            } : function(e, t) {
                e.default = t;
            }, i = function(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)"default" !== n && Object.hasOwnProperty.call(e, n) && o(t, e, n);
                return r(t, e), t;
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.DosUi = void 0;
            var s = i(e("./js-dos-dom")), e = (a.prototype.onprogress = function(e, t, n) {
                e = (e = 32 < e.length ? "\u2026" + e.substr(-32) : e) + " " + Math.round(100 * n / t * 10) / 10 + "%";
                null !== this.loaderMessage && (this.loaderMessage.innerHTML = e), this.dos.info(e), t <= n ? this.hide() : this.show();
            }, a.prototype.detach = function() {
                this.hide(), this.onprogress = this.onprogressFallback;
            }, a.prototype.hide = function() {
                this.hidden || (this.hidden = !0, null !== this.overlay && this.overlay.setAttribute("style", "display: none"));
            }, a.prototype.show = function() {
                this.hidden && (this.hidden = !1, null !== this.overlay && this.overlay.setAttribute("style", "display: block"));
            }, a.prototype.onprogressFallback = function(e, t, n) {
                this.dos.info(e + " " + 100 * n / t + "%");
            }, a.prototype.childById = function(e, t) {
                if (null === e) return null;
                for(var n = 0; n < e.childElementCount; ++n){
                    var o = e.children[n];
                    if (o.className === t) return o;
                    if (null !== (o = this.childById(o, t))) return o;
                }
                return null;
            }, a);
            function a(e) {
                this.overlay = null, this.loaderMessage = null, this.hidden = !0, this.css = '\n    .dosbox-container { position: relative; min-width: 320px; min-height: 200px; display: flex; flex-direction: column; justify-content: center; align-items: center; }\n    .dosbox-overlay, .dosbox-loader { position: absolute; left: 0; right: 0; top: 0; bottom: 0; background-color: rgba(51, 51, 51, 0.7); }\n    .dosbox-start { text-align: center; position: absolute; left: 0; right: 0; bottom: 50%; color: #fff; font-size: 1.5em; text-decoration: underline; cursor: pointer; }\n    .dosbox-overlay a { color: #fff; }\n    .dosbox-powered { position: absolute; right: 1em; bottom: 1em; font-size: 0.8em; color: #9C9C9C; }\n    .dosbox-loader-message { text-align: center; position: absolute; left: 0; right: 0; bottom: 50%; margin: 0 0 -3em 0; box-sizing: border-box; color: #fff; font-size: 1.5em; }\n    @-moz-keyframes loading { 0% { left: 0; } 50% { left: 8.33333em; } 100% { left: 0; } } @-webkit-keyframes loading { 0% { left: 0; } 50% { left: 8.33333em; } 100% { left: 0; } } @keyframes loading { 0% { left: 0; } 50% { left: 8.33333em; } 100% { left: 0; } } .st-loader { width: 10em; height: 2.5em; position: absolute; top: 50%; left: 50%; margin: -1.25em 0 0 -5em; box-sizing: border-box; }\n    .st-loader:before, .st-loader:after { content: ""; display: block; position: absolute; top: 0; bottom: 0; width: 1.25em; box-sizing: border-box; border: 0.25em solid #fff; }\n    .st-loader:before { left: -0.76923em; border-right: 0; }\n    .st-loader:after { right: -0.76923em; border-left: 0; }\n    .st-loader .equal { display: block; position: absolute; top: 50%; margin-top: -0.5em; left: 4.16667em; height: 1em; width: 1.66667em; border: 0.25em solid #fff; box-sizing: border-box; border-width: 0.25em 0; -moz-animation: loading 1.5s infinite ease-in-out; -webkit-animation: loading 1.5s infinite ease-in-out; animation: loading 1.5s infinite ease-in-out; background: #fff; }\n    ', this.overlayHtml = '\n        <div class="dosbox-loader">\n            <div class="st-loader">\n                <span class="equal"></span>\n            </div>\n            <div class="dosbox-loader-message"></div>\n        </div>\n        <div class="dosbox-powered">\n            Powered by &nbsp;<a href="https://js-dos.com">js-dos.com</a> (6.22)\n        </div>\n    ', this.dos = e, this.canvas = e.canvas;
                try {
                    var t, n;
                    s.applyCss("js-dos-ui-css", this.css), null !== this.canvas.parentElement && "dosbox-container" !== this.canvas.parentElement.className && (t = s.createDiv("dosbox-container"), this.canvas.parentElement.replaceChild(t, this.canvas), t.appendChild(this.canvas), n = s.createDiv("dosbox-overlay"), t.appendChild(n), n.innerHTML = this.overlayHtml);
                    var o = this.canvas.parentElement;
                    if (null === o) throw new Error("Illegal state, container is null");
                    if (this.overlay = this.childById(o, "dosbox-overlay"), null === this.overlay) throw new Error("Illegal state, overlay is null");
                    this.loaderMessage = this.childById(this.overlay, "dosbox-loader-message"), this.hidden = !0, this.show();
                } catch (e) {
                    this.onprogress = this.onprogressFallback;
                }
            }
            n.DosUi = e;
        },
        {
            "./js-dos-dom": 10
        }
    ],
    16: [
        function(e, t, n) {
            "use strict";
            var o = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.Xhr = void 0;
            var r = o(e("./js-dos-cache-noop")), e = (i.prototype.makeHttpRequest = function() {
                var e, t = this;
                this.xhr = new XMLHttpRequest, this.xhr.open(this.options.method || "GET", this.resource, !0), "POST" === this.options.method && this.xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), this.xhr.overrideMimeType("text/plain; charset=x-user-defined"), "function" == typeof (e = this.xhr).addEventListener && e.addEventListener("progress", function(e) {
                    if (t.total = e.total, t.loaded = e.loaded, t.options.progress) return t.options.progress(e.total, e.loaded);
                }), "function" == typeof (e = this.xhr).addEventListener && e.addEventListener("error", function(e) {
                    if (t.options.fail) return t.options.fail(t.resource, t.xhr.status, "connection problem"), delete t.options.fail;
                }), this.xhr.onreadystatechange = function() {
                    return t.onReadyStateChange();
                }, this.options.responseType && (this.xhr.responseType = this.options.responseType), this.xhr.send(this.options.data);
            }, i.prototype.onReadyStateChange = function() {
                var e = this.xhr;
                if (4 === e.readyState) {
                    if (200 === e.status) {
                        if (this.options.success) {
                            var t = Math.max(this.total, this.loaded);
                            return void 0 !== this.options.progress && this.options.progress(t, t), "GET" === this.options.method && this.resource.indexOf("?") < 0 && this.cache.put(this.resource, e.response, function() {}), this.options.success(e.response);
                        }
                    } else if (this.options.fail) return this.options.fail(this.resource, e.status, "connection problem"), delete this.options.fail;
                }
            }, i);
            function i(e, t) {
                var n = this;
                this.xhr = null, this.total = 0, this.loaded = 0, this.resource = e, this.options = t, this.options.method = t.method || "GET", this.cache = t.cache || new r.default, "GET" === this.options.method && this.cache.get(this.resource, function(e) {
                    void 0 !== n.options.success && n.options.success(e);
                }, function() {
                    n.makeHttpRequest();
                });
            }
            n.Xhr = e;
        },
        {
            "./js-dos-cache-noop": 6
        }
    ],
    17: [
        function(e, t, n) {
            "use strict";
            e("core-js/modules/es6.object.to-string.js"), e("core-js/modules/es6.promise.js"), e("core-js/modules/es6.object.assign.js");
            var o = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var s = o(e("./js-dos-cache")), a = e("./js-dos-host"), c = e("./js-dos-module"), r = o(e("./controller/gamepad")), i = o(e("./controller/move")), o = o(e("./controller/qwerty")), e = function(r, i) {
                var e = new Promise(function(e, t) {
                    var n = new c.DosModule(r, e);
                    (i = i || {}).onerror || (i.onerror = function(e) {
                        console.error(e);
                    }), Object.assign(n, i);
                    var o = n.onerror;
                    n.onerror = function(e) {
                        t(e);
                        setTimeout(function() {
                            o ? (o(e), n.onerror = o) : n.onerror = n.error;
                        }, 1);
                    }, n.resolve(), n.isValid && s.default(n, function(e) {
                        a.Host.resolveDosBox(n.wdosboxUrl, e, n);
                    });
                });
                return e.ready = function(t) {
                    return e.then(function(e) {
                        t(e.fs, e.main);
                    }), e;
                }, e;
            };
            n.default = e, window.Dos = e, window.DosController = {
                Qwerty: o.default,
                Move: i.default,
                Gamepad: r.default
            };
        },
        {
            "./controller/gamepad": 1,
            "./controller/move": 2,
            "./controller/qwerty": 3,
            "./js-dos-cache": 7,
            "./js-dos-host": 12,
            "./js-dos-module": 13,
            "core-js/modules/es6.object.assign.js": 121,
            "core-js/modules/es6.object.to-string.js": 123,
            "core-js/modules/es6.promise.js": 124
        }
    ],
    18: [
        function(e, t, n) {
            t.exports = function(e) {
                if ("function" != typeof e) throw TypeError(e + " is not a function!");
                return e;
            };
        },
        {}
    ],
    19: [
        function(e, t, n) {
            var o = e("./_wks")("unscopables"), r = Array.prototype;
            null == r[o] && e("./_hide")(r, o, {}), t.exports = function(e) {
                r[o][e] = !0;
            };
        },
        {
            "./_hide": 47,
            "./_wks": 112
        }
    ],
    20: [
        function(e, t, n) {
            "use strict";
            var o = e("./_string-at")(!0);
            t.exports = function(e, t, n) {
                return t + (n ? o(e, t).length : 1);
            };
        },
        {
            "./_string-at": 95
        }
    ],
    21: [
        function(e, t, n) {
            t.exports = function(e, t, n, o) {
                if (!(e instanceof t) || void 0 !== o && o in e) throw TypeError(n + ": incorrect invocation!");
                return e;
            };
        },
        {}
    ],
    22: [
        function(e, t, n) {
            var o = e("./_is-object");
            t.exports = function(e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
            };
        },
        {
            "./_is-object": 55
        }
    ],
    23: [
        function(e, t, n) {
            "use strict";
            var c = e("./_to-object"), u = e("./_to-absolute-index"), l = e("./_to-length");
            t.exports = [].copyWithin || function(e, t) {
                var n = c(this), o = l(n.length), r = u(e, o), i = u(t, o), t = 2 < arguments.length ? arguments[2] : void 0, s = Math.min((void 0 === t ? o : u(t, o)) - i, o - r), a = 1;
                for(i < r && r < i + s && (a = -1, i += s - 1, r += s - 1); 0 < s--;)i in n ? n[r] = n[i] : delete n[r], r += a, i += a;
                return n;
            };
        },
        {
            "./_to-absolute-index": 98,
            "./_to-length": 102,
            "./_to-object": 103
        }
    ],
    24: [
        function(e, t, n) {
            "use strict";
            var s = e("./_to-object"), a = e("./_to-absolute-index"), c = e("./_to-length");
            t.exports = function(e) {
                for(var t = s(this), n = c(t.length), o = arguments.length, r = a(1 < o ? arguments[1] : void 0, n), o = 2 < o ? arguments[2] : void 0, i = void 0 === o ? n : a(o, n); r < i;)t[r++] = e;
                return t;
            };
        },
        {
            "./_to-absolute-index": 98,
            "./_to-length": 102,
            "./_to-object": 103
        }
    ],
    25: [
        function(e, t, n) {
            var c = e("./_to-iobject"), u = e("./_to-length"), l = e("./_to-absolute-index");
            t.exports = function(a) {
                return function(e, t, n) {
                    var o, r = c(e), i = u(r.length), s = l(n, i);
                    if (a && t != t) {
                        for(; s < i;)if ((o = r[s++]) != o) return !0;
                    } else for(; s < i; s++)if ((a || s in r) && r[s] === t) return a || s || 0;
                    return !a && -1;
                };
            };
        },
        {
            "./_to-absolute-index": 98,
            "./_to-iobject": 101,
            "./_to-length": 102
        }
    ],
    26: [
        function(e, t, n) {
            var v = e("./_ctx"), y = e("./_iobject"), j = e("./_to-object"), x = e("./_to-length"), o = e("./_array-species-create");
            t.exports = function(f, e) {
                var d = 1 == f, p = 2 == f, h = 3 == f, _ = 4 == f, g = 6 == f, b = 5 == f || g, m = e || o;
                return function(e, t, n) {
                    for(var o, r, i = j(e), s = y(i), a = v(t, n, 3), c = x(s.length), u = 0, l = d ? m(e, c) : p ? m(e, 0) : void 0; u < c; u++)if ((b || u in s) && (r = a(o = s[u], u, i), f)) {
                        if (d) l[u] = r;
                        else if (r) switch(f){
                            case 3:
                                return !0;
                            case 5:
                                return o;
                            case 6:
                                return u;
                            case 2:
                                l.push(o);
                        }
                        else if (_) return !1;
                    }
                    return g ? -1 : h || _ ? _ : l;
                };
            };
        },
        {
            "./_array-species-create": 28,
            "./_ctx": 32,
            "./_iobject": 52,
            "./_to-length": 102,
            "./_to-object": 103
        }
    ],
    27: [
        function(e, t, n) {
            var o = e("./_is-object"), r = e("./_is-array"), i = e("./_wks")("species");
            t.exports = function(e) {
                var t;
                return r(e) && ("function" != typeof (t = e.constructor) || t !== Array && !r(t.prototype) || (t = void 0), o(t) && null === (t = t[i]) && (t = void 0)), void 0 === t ? Array : t;
            };
        },
        {
            "./_is-array": 54,
            "./_is-object": 55,
            "./_wks": 112
        }
    ],
    28: [
        function(e, t, n) {
            var o = e("./_array-species-constructor");
            t.exports = function(e, t) {
                return new (o(e))(t);
            };
        },
        {
            "./_array-species-constructor": 27
        }
    ],
    29: [
        function(e, t, n) {
            var o = e("./_cof"), r = e("./_wks")("toStringTag"), i = "Arguments" == o(function() {
                return arguments;
            }());
            t.exports = function(e) {
                var t;
                return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (e = function(e, t) {
                    try {
                        return e[t];
                    } catch (e) {}
                }(t = Object(e), r)) ? e : i ? o(t) : "Object" == (e = o(t)) && "function" == typeof t.callee ? "Arguments" : e;
            };
        },
        {
            "./_cof": 30,
            "./_wks": 112
        }
    ],
    30: [
        function(e, t, n) {
            var o = {}.toString;
            t.exports = function(e) {
                return o.call(e).slice(8, -1);
            };
        },
        {}
    ],
    31: [
        function(e, t, n) {
            t = t.exports = {
                version: "2.6.12"
            };
            "number" == typeof __e && (__e = t);
        },
        {}
    ],
    32: [
        function(e, t, n) {
            var i = e("./_a-function");
            t.exports = function(o, r, e) {
                if (i(o), void 0 === r) return o;
                switch(e){
                    case 1:
                        return function(e) {
                            return o.call(r, e);
                        };
                    case 2:
                        return function(e, t) {
                            return o.call(r, e, t);
                        };
                    case 3:
                        return function(e, t, n) {
                            return o.call(r, e, t, n);
                        };
                }
                return function() {
                    return o.apply(r, arguments);
                };
            };
        },
        {
            "./_a-function": 18
        }
    ],
    33: [
        function(e, t, n) {
            t.exports = function(e) {
                if (null == e) throw TypeError("Can't call method on  " + e);
                return e;
            };
        },
        {}
    ],
    34: [
        function(e, t, n) {
            t.exports = !e("./_fails")(function() {
                return 7 != Object.defineProperty({}, "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        {
            "./_fails": 40
        }
    ],
    35: [
        function(e, t, n) {
            var o = e("./_is-object"), r = e("./_global").document, i = o(r) && o(r.createElement);
            t.exports = function(e) {
                return i ? r.createElement(e) : {};
            };
        },
        {
            "./_global": 45,
            "./_is-object": 55
        }
    ],
    36: [
        function(e, t, n) {
            t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
        },
        {}
    ],
    37: [
        function(e, t, n) {
            var a = e("./_object-keys"), c = e("./_object-gops"), u = e("./_object-pie");
            t.exports = function(e) {
                var t = a(e), n = c.f;
                if (n) for(var o, r = n(e), i = u.f, s = 0; r.length > s;)i.call(e, o = r[s++]) && t.push(o);
                return t;
            };
        },
        {
            "./_object-gops": 76,
            "./_object-keys": 79,
            "./_object-pie": 80
        }
    ],
    38: [
        function(e, t, n) {
            var h = e("./_global"), _ = e("./_core"), g = e("./_hide"), b = e("./_redefine"), m = e("./_ctx"), v = "prototype", y = function(e, t, n) {
                var o, r, i, s = e & y.F, a = e & y.G, c = e & y.S, u = e & y.P, l = e & y.B, f = a ? h : c ? h[t] || (h[t] = {}) : (h[t] || {})[v], d = a ? _ : _[t] || (_[t] = {}), p = d[v] || (d[v] = {});
                for(o in n = a ? t : n)r = ((i = !s && f && void 0 !== f[o]) ? f : n)[o], i = l && i ? m(r, h) : u && "function" == typeof r ? m(Function.call, r) : r, f && b(f, o, r, e & y.U), d[o] != r && g(d, o, i), u && p[o] != r && (p[o] = r);
            };
            h.core = _, y.F = 1, y.G = 2, y.S = 4, y.P = 8, y.B = 16, y.W = 32, y.U = 64, y.R = 128, t.exports = y;
        },
        {
            "./_core": 31,
            "./_ctx": 32,
            "./_global": 45,
            "./_hide": 47,
            "./_redefine": 86
        }
    ],
    39: [
        function(e, t, n) {
            var o = e("./_wks")("match");
            t.exports = function(t) {
                var n = /./;
                try {
                    "/./"[t](n);
                } catch (e) {
                    try {
                        return n[o] = !1, !"/./"[t](n);
                    } catch (e) {}
                }
                return !0;
            };
        },
        {
            "./_wks": 112
        }
    ],
    40: [
        function(e, t, n) {
            t.exports = function(e) {
                try {
                    return !!e();
                } catch (e) {
                    return !0;
                }
            };
        },
        {}
    ],
    41: [
        function(e, t, n) {
            "use strict";
            e("./es6.regexp.exec");
            var c = e("./_redefine"), u = e("./_hide"), l = e("./_fails"), f = e("./_defined"), d = e("./_wks"), p = e("./_regexp-exec"), h = d("species"), _ = !l(function() {
                var e = /./;
                return e.exec = function() {
                    var e = [];
                    return e.groups = {
                        a: "7"
                    }, e;
                }, "7" !== "".replace(e, "$<a>");
            }), g = function() {
                var e = /(?:)/, t = e.exec;
                e.exec = function() {
                    return t.apply(this, arguments);
                };
                e = "ab".split(e);
                return 2 === e.length && "a" === e[0] && "b" === e[1];
            }();
            t.exports = function(n, e, t) {
                var i, o, r = d(n), s = !l(function() {
                    var e = {};
                    return e[r] = function() {
                        return 7;
                    }, 7 != ""[n](e);
                }), a = s ? !l(function() {
                    var e = !1, t = /a/;
                    return t.exec = function() {
                        return e = !0, null;
                    }, "split" === n && (t.constructor = {}, t.constructor[h] = function() {
                        return t;
                    }), t[r](""), !e;
                }) : void 0;
                s && a && ("replace" !== n || _) && ("split" !== n || g) || (i = /./[r], t = (a = t(f, r, ""[n], function(e, t, n, o, r) {
                    return t.exec === p ? s && !r ? {
                        done: !0,
                        value: i.call(t, n, o)
                    } : {
                        done: !0,
                        value: e.call(n, t, o)
                    } : {
                        done: !1
                    };
                }))[0], o = a[1], c(String.prototype, n, t), u(RegExp.prototype, r, 2 == e ? function(e, t) {
                    return o.call(e, this, t);
                } : function(e) {
                    return o.call(e, this);
                }));
            };
        },
        {
            "./_defined": 33,
            "./_fails": 40,
            "./_hide": 47,
            "./_redefine": 86,
            "./_regexp-exec": 88,
            "./_wks": 112,
            "./es6.regexp.exec": 126
        }
    ],
    42: [
        function(e, t, n) {
            "use strict";
            var o = e("./_an-object");
            t.exports = function() {
                var e = o(this), t = "";
                return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
            };
        },
        {
            "./_an-object": 22
        }
    ],
    43: [
        function(e, t, n) {
            var f = e("./_ctx"), d = e("./_iter-call"), p = e("./_is-array-iter"), h = e("./_an-object"), _ = e("./_to-length"), g = e("./core.get-iterator-method"), b = {}, m = {};
            (n = t.exports = function(e, t, n, o, r) {
                var i, s, a, c, r = r ? function() {
                    return e;
                } : g(e), u = f(n, o, t ? 2 : 1), l = 0;
                if ("function" != typeof r) throw TypeError(e + " is not iterable!");
                if (p(r)) {
                    for(i = _(e.length); l < i; l++)if ((c = t ? u(h(s = e[l])[0], s[1]) : u(e[l])) === b || c === m) return c;
                } else for(a = r.call(e); !(s = a.next()).done;)if ((c = d(a, u, s.value, t)) === b || c === m) return c;
            }).BREAK = b, n.RETURN = m;
        },
        {
            "./_an-object": 22,
            "./_ctx": 32,
            "./_is-array-iter": 53,
            "./_iter-call": 57,
            "./_to-length": 102,
            "./core.get-iterator-method": 113
        }
    ],
    44: [
        function(e, t, n) {
            t.exports = e("./_shared")("native-function-to-string", Function.toString);
        },
        {
            "./_shared": 93
        }
    ],
    45: [
        function(e, t, n) {
            t = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
            "number" == typeof __g && (__g = t);
        },
        {}
    ],
    46: [
        function(e, t, n) {
            var o = {}.hasOwnProperty;
            t.exports = function(e, t) {
                return o.call(e, t);
            };
        },
        {}
    ],
    47: [
        function(e, t, n) {
            var o = e("./_object-dp"), r = e("./_property-desc");
            t.exports = e("./_descriptors") ? function(e, t, n) {
                return o.f(e, t, r(1, n));
            } : function(e, t, n) {
                return e[t] = n, e;
            };
        },
        {
            "./_descriptors": 34,
            "./_object-dp": 71,
            "./_property-desc": 84
        }
    ],
    48: [
        function(e, t, n) {
            e = e("./_global").document;
            t.exports = e && e.documentElement;
        },
        {
            "./_global": 45
        }
    ],
    49: [
        function(e, t, n) {
            t.exports = !e("./_descriptors") && !e("./_fails")(function() {
                return 7 != Object.defineProperty(e("./_dom-create")("div"), "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        {
            "./_descriptors": 34,
            "./_dom-create": 35,
            "./_fails": 40
        }
    ],
    50: [
        function(e, t, n) {
            var r = e("./_is-object"), i = e("./_set-proto").set;
            t.exports = function(e, t, n) {
                var o, t = t.constructor;
                return t !== n && "function" == typeof t && (o = t.prototype) !== n.prototype && r(o) && i && i(e, o), e;
            };
        },
        {
            "./_is-object": 55,
            "./_set-proto": 89
        }
    ],
    51: [
        function(e, t, n) {
            t.exports = function(e, t, n) {
                var o = void 0 === n;
                switch(t.length){
                    case 0:
                        return o ? e() : e.call(n);
                    case 1:
                        return o ? e(t[0]) : e.call(n, t[0]);
                    case 2:
                        return o ? e(t[0], t[1]) : e.call(n, t[0], t[1]);
                    case 3:
                        return o ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);
                    case 4:
                        return o ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3]);
                }
                return e.apply(n, t);
            };
        },
        {}
    ],
    52: [
        function(e, t, n) {
            var o = e("./_cof");
            t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(e) {
                return "String" == o(e) ? e.split("") : Object(e);
            };
        },
        {
            "./_cof": 30
        }
    ],
    53: [
        function(e, t, n) {
            var o = e("./_iterators"), r = e("./_wks")("iterator"), i = Array.prototype;
            t.exports = function(e) {
                return void 0 !== e && (o.Array === e || i[r] === e);
            };
        },
        {
            "./_iterators": 62,
            "./_wks": 112
        }
    ],
    54: [
        function(e, t, n) {
            var o = e("./_cof");
            t.exports = Array.isArray || function(e) {
                return "Array" == o(e);
            };
        },
        {
            "./_cof": 30
        }
    ],
    55: [
        function(e, t, n) {
            t.exports = function(e) {
                return "object" == typeof e ? null !== e : "function" == typeof e;
            };
        },
        {}
    ],
    56: [
        function(e, t, n) {
            var o = e("./_is-object"), r = e("./_cof"), i = e("./_wks")("match");
            t.exports = function(e) {
                var t;
                return o(e) && (void 0 !== (t = e[i]) ? !!t : "RegExp" == r(e));
            };
        },
        {
            "./_cof": 30,
            "./_is-object": 55,
            "./_wks": 112
        }
    ],
    57: [
        function(e, t, n) {
            var r = e("./_an-object");
            t.exports = function(t, e, n, o) {
                try {
                    return o ? e(r(n)[0], n[1]) : e(n);
                } catch (e) {
                    n = t.return;
                    throw void 0 !== n && r(n.call(t)), e;
                }
            };
        },
        {
            "./_an-object": 22
        }
    ],
    58: [
        function(e, t, n) {
            "use strict";
            var o = e("./_object-create"), r = e("./_property-desc"), i = e("./_set-to-string-tag"), s = {};
            e("./_hide")(s, e("./_wks")("iterator"), function() {
                return this;
            }), t.exports = function(e, t, n) {
                e.prototype = o(s, {
                    next: r(1, n)
                }), i(e, t + " Iterator");
            };
        },
        {
            "./_hide": 47,
            "./_object-create": 70,
            "./_property-desc": 84,
            "./_set-to-string-tag": 91,
            "./_wks": 112
        }
    ],
    59: [
        function(e, t, n) {
            "use strict";
            function m() {
                return this;
            }
            var v = e("./_library"), y = e("./_export"), j = e("./_redefine"), x = e("./_hide"), w = e("./_iterators"), k = e("./_iter-create"), S = e("./_set-to-string-tag"), E = e("./_object-gpo"), P = e("./_wks")("iterator"), O = !([].keys && "next" in [].keys()), A = "values";
            t.exports = function(e, t, n, o, r, i, s) {
                k(n, t, o);
                function a(e) {
                    if (!O && e in h) return h[e];
                    switch(e){
                        case "keys":
                        case A:
                            return function() {
                                return new n(this, e);
                            };
                    }
                    return function() {
                        return new n(this, e);
                    };
                }
                var c, u, l, f = t + " Iterator", d = r == A, p = !1, h = e.prototype, _ = h[P] || h["@@iterator"] || r && h[r], g = _ || a(r), b = r ? d ? a("entries") : g : void 0, o = "Array" == t && h.entries || _;
                if (o && (l = E(o.call(new e))) !== Object.prototype && l.next && (S(l, f, !0), v || "function" == typeof l[P] || x(l, P, m)), d && _ && _.name !== A && (p = !0, g = function() {
                    return _.call(this);
                }), v && !s || !O && !p && h[P] || x(h, P, g), w[t] = g, w[f] = m, r) {
                    if (c = {
                        values: d ? g : a(A),
                        keys: i ? g : a("keys"),
                        entries: b
                    }, s) for(u in c)u in h || j(h, u, c[u]);
                    else y(y.P + y.F * (O || p), t, c);
                }
                return c;
            };
        },
        {
            "./_export": 38,
            "./_hide": 47,
            "./_iter-create": 58,
            "./_iterators": 62,
            "./_library": 63,
            "./_object-gpo": 77,
            "./_redefine": 86,
            "./_set-to-string-tag": 91,
            "./_wks": 112
        }
    ],
    60: [
        function(e, t, n) {
            var i = e("./_wks")("iterator"), s = !1;
            try {
                var o = [
                    7
                ][i]();
                o.return = function() {
                    s = !0;
                }, Array.from(o, function() {
                    throw 2;
                });
            } catch (e) {}
            t.exports = function(e, t) {
                if (!t && !s) return !1;
                var n = !1;
                try {
                    var o = [
                        7
                    ], r = o[i]();
                    r.next = function() {
                        return {
                            done: n = !0
                        };
                    }, o[i] = function() {
                        return r;
                    }, e(o);
                } catch (e) {}
                return n;
            };
        },
        {
            "./_wks": 112
        }
    ],
    61: [
        function(e, t, n) {
            t.exports = function(e, t) {
                return {
                    value: t,
                    done: !!e
                };
            };
        },
        {}
    ],
    62: [
        function(e, t, n) {
            t.exports = {};
        },
        {}
    ],
    63: [
        function(e, t, n) {
            t.exports = !1;
        },
        {}
    ],
    64: [
        function(e, t, n) {
            var o = e("./_math-sign"), e = Math.pow, r = e(2, -52), i = e(2, -23), s = e(2, 127) * (2 - i), a = e(2, -126);
            t.exports = Math.fround || function(e) {
                var t = Math.abs(e), n = o(e);
                return t < a ? n * (t / a / i + 1 / r - 1 / r) * a * i : s < (t = (e = (1 + i / r) * t) - (e - t)) || t != t ? n * (1 / 0) : n * t;
            };
        },
        {
            "./_math-sign": 65
        }
    ],
    65: [
        function(e, t, n) {
            t.exports = Math.sign || function(e) {
                return 0 == (e = +e) || e != e ? e : e < 0 ? -1 : 1;
            };
        },
        {}
    ],
    66: [
        function(e, t, n) {
            function o(e) {
                a(e, r, {
                    value: {
                        i: "O" + ++c,
                        w: {}
                    }
                });
            }
            var r = e("./_uid")("meta"), i = e("./_is-object"), s = e("./_has"), a = e("./_object-dp").f, c = 0, u = Object.isExtensible || function() {
                return !0;
            }, l = !e("./_fails")(function() {
                return u(Object.preventExtensions({}));
            }), f = t.exports = {
                KEY: r,
                NEED: !1,
                fastKey: function(e, t) {
                    if (!i(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
                    if (!s(e, r)) {
                        if (!u(e)) return "F";
                        if (!t) return "E";
                        o(e);
                    }
                    return e[r].i;
                },
                getWeak: function(e, t) {
                    if (!s(e, r)) {
                        if (!u(e)) return !0;
                        if (!t) return !1;
                        o(e);
                    }
                    return e[r].w;
                },
                onFreeze: function(e) {
                    return l && f.NEED && u(e) && !s(e, r) && o(e), e;
                }
            };
        },
        {
            "./_fails": 40,
            "./_has": 46,
            "./_is-object": 55,
            "./_object-dp": 71,
            "./_uid": 108
        }
    ],
    67: [
        function(e, t, n) {
            var a = e("./_global"), c = e("./_task").set, u = a.MutationObserver || a.WebKitMutationObserver, l = a.process, f = a.Promise, d = "process" == e("./_cof")(l);
            t.exports = function() {
                function e() {
                    var e, t;
                    for(d && (e = l.domain) && e.exit(); n;){
                        t = n.fn, n = n.next;
                        try {
                            t();
                        } catch (e) {
                            throw n ? r() : o = void 0, e;
                        }
                    }
                    o = void 0, e && e.enter();
                }
                var n, o, t, r, i, s;
                return r = d ? function() {
                    l.nextTick(e);
                } : !u || a.navigator && a.navigator.standalone ? f && f.resolve ? (t = f.resolve(void 0), function() {
                    t.then(e);
                }) : function() {
                    c.call(a, e);
                } : (i = !0, s = document.createTextNode(""), new u(e).observe(s, {
                    characterData: !0
                }), function() {
                    s.data = i = !i;
                }), function(e) {
                    e = {
                        fn: e,
                        next: void 0
                    };
                    o && (o.next = e), n || (n = e, r()), o = e;
                };
            };
        },
        {
            "./_cof": 30,
            "./_global": 45,
            "./_task": 97
        }
    ],
    68: [
        function(e, t, n) {
            "use strict";
            var r = e("./_a-function");
            function o(e) {
                var n, o;
                this.promise = new e(function(e, t) {
                    if (void 0 !== n || void 0 !== o) throw TypeError("Bad Promise constructor");
                    n = e, o = t;
                }), this.resolve = r(n), this.reject = r(o);
            }
            t.exports.f = function(e) {
                return new o(e);
            };
        },
        {
            "./_a-function": 18
        }
    ],
    69: [
        function(e, t, n) {
            "use strict";
            var d = e("./_descriptors"), p = e("./_object-keys"), h = e("./_object-gops"), _ = e("./_object-pie"), g = e("./_to-object"), b = e("./_iobject"), r = Object.assign;
            t.exports = !r || e("./_fails")(function() {
                var e = {}, t = {}, n = Symbol(), o = "abcdefghijklmnopqrst";
                return e[n] = 7, o.split("").forEach(function(e) {
                    t[e] = e;
                }), 7 != r({}, e)[n] || Object.keys(r({}, t)).join("") != o;
            }) ? function(e, t) {
                for(var n = g(e), o = arguments.length, r = 1, i = h.f, s = _.f; r < o;)for(var a, c = b(arguments[r++]), u = i ? p(c).concat(i(c)) : p(c), l = u.length, f = 0; f < l;)a = u[f++], d && !s.call(c, a) || (n[a] = c[a]);
                return n;
            } : r;
        },
        {
            "./_descriptors": 34,
            "./_fails": 40,
            "./_iobject": 52,
            "./_object-gops": 76,
            "./_object-keys": 79,
            "./_object-pie": 80,
            "./_to-object": 103
        }
    ],
    70: [
        function(n, e, t) {
            function o() {}
            var r = n("./_an-object"), i = n("./_object-dps"), s = n("./_enum-bug-keys"), a = n("./_shared-key")("IE_PROTO"), c = "prototype", u = function() {
                var e = n("./_dom-create")("iframe"), t = s.length;
                for(e.style.display = "none", n("./_html").appendChild(e), e.src = "javascript:", (e = e.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), u = e.F; t--;)delete u[c][s[t]];
                return u();
            };
            e.exports = Object.create || function(e, t) {
                var n;
                return null !== e ? (o[c] = r(e), n = new o, o[c] = null, n[a] = e) : n = u(), void 0 === t ? n : i(n, t);
            };
        },
        {
            "./_an-object": 22,
            "./_dom-create": 35,
            "./_enum-bug-keys": 36,
            "./_html": 48,
            "./_object-dps": 72,
            "./_shared-key": 92
        }
    ],
    71: [
        function(e, t, n) {
            var o = e("./_an-object"), r = e("./_ie8-dom-define"), i = e("./_to-primitive"), s = Object.defineProperty;
            n.f = e("./_descriptors") ? Object.defineProperty : function(e, t, n) {
                if (o(e), t = i(t, !0), o(n), r) try {
                    return s(e, t, n);
                } catch (e) {}
                if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
                return "value" in n && (e[t] = n.value), e;
            };
        },
        {
            "./_an-object": 22,
            "./_descriptors": 34,
            "./_ie8-dom-define": 49,
            "./_to-primitive": 104
        }
    ],
    72: [
        function(e, t, n) {
            var s = e("./_object-dp"), a = e("./_an-object"), c = e("./_object-keys");
            t.exports = e("./_descriptors") ? Object.defineProperties : function(e, t) {
                a(e);
                for(var n, o = c(t), r = o.length, i = 0; i < r;)s.f(e, n = o[i++], t[n]);
                return e;
            };
        },
        {
            "./_an-object": 22,
            "./_descriptors": 34,
            "./_object-dp": 71,
            "./_object-keys": 79
        }
    ],
    73: [
        function(e, t, n) {
            var o = e("./_object-pie"), r = e("./_property-desc"), i = e("./_to-iobject"), s = e("./_to-primitive"), a = e("./_has"), c = e("./_ie8-dom-define"), u = Object.getOwnPropertyDescriptor;
            n.f = e("./_descriptors") ? u : function(e, t) {
                if (e = i(e), t = s(t, !0), c) try {
                    return u(e, t);
                } catch (e) {}
                if (a(e, t)) return r(!o.f.call(e, t), e[t]);
            };
        },
        {
            "./_descriptors": 34,
            "./_has": 46,
            "./_ie8-dom-define": 49,
            "./_object-pie": 80,
            "./_property-desc": 84,
            "./_to-iobject": 101,
            "./_to-primitive": 104
        }
    ],
    74: [
        function(e, t, n) {
            var o = e("./_to-iobject"), r = e("./_object-gopn").f, i = {}.toString, s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
            t.exports.f = function(e) {
                return s && "[object Window]" == i.call(e) ? function(e) {
                    try {
                        return r(e);
                    } catch (e) {
                        return s.slice();
                    }
                }(e) : r(o(e));
            };
        },
        {
            "./_object-gopn": 75,
            "./_to-iobject": 101
        }
    ],
    75: [
        function(e, t, n) {
            var o = e("./_object-keys-internal"), r = e("./_enum-bug-keys").concat("length", "prototype");
            n.f = Object.getOwnPropertyNames || function(e) {
                return o(e, r);
            };
        },
        {
            "./_enum-bug-keys": 36,
            "./_object-keys-internal": 78
        }
    ],
    76: [
        function(e, t, n) {
            n.f = Object.getOwnPropertySymbols;
        },
        {}
    ],
    77: [
        function(e, t, n) {
            var o = e("./_has"), r = e("./_to-object"), i = e("./_shared-key")("IE_PROTO"), s = Object.prototype;
            t.exports = Object.getPrototypeOf || function(e) {
                return e = r(e), o(e, i) ? e[i] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? s : null;
            };
        },
        {
            "./_has": 46,
            "./_shared-key": 92,
            "./_to-object": 103
        }
    ],
    78: [
        function(e, t, n) {
            var s = e("./_has"), a = e("./_to-iobject"), c = e("./_array-includes")(!1), u = e("./_shared-key")("IE_PROTO");
            t.exports = function(e, t) {
                var n, o = a(e), r = 0, i = [];
                for(n in o)n != u && s(o, n) && i.push(n);
                for(; t.length > r;)s(o, n = t[r++]) && (~c(i, n) || i.push(n));
                return i;
            };
        },
        {
            "./_array-includes": 25,
            "./_has": 46,
            "./_shared-key": 92,
            "./_to-iobject": 101
        }
    ],
    79: [
        function(e, t, n) {
            var o = e("./_object-keys-internal"), r = e("./_enum-bug-keys");
            t.exports = Object.keys || function(e) {
                return o(e, r);
            };
        },
        {
            "./_enum-bug-keys": 36,
            "./_object-keys-internal": 78
        }
    ],
    80: [
        function(e, t, n) {
            n.f = ({}).propertyIsEnumerable;
        },
        {}
    ],
    81: [
        function(e, t, n) {
            var r = e("./_export"), i = e("./_core"), s = e("./_fails");
            t.exports = function(e, t) {
                var n = (i.Object || {})[e] || Object[e], o = {};
                o[e] = t(n), r(r.S + r.F * s(function() {
                    n(1);
                }), "Object", o);
            };
        },
        {
            "./_core": 31,
            "./_export": 38,
            "./_fails": 40
        }
    ],
    82: [
        function(e, t, n) {
            t.exports = function(e) {
                try {
                    return {
                        e: !1,
                        v: e()
                    };
                } catch (e) {
                    return {
                        e: !0,
                        v: e
                    };
                }
            };
        },
        {}
    ],
    83: [
        function(e, t, n) {
            var o = e("./_an-object"), r = e("./_is-object"), i = e("./_new-promise-capability");
            t.exports = function(e, t) {
                if (o(e), r(t) && t.constructor === e) return t;
                e = i.f(e);
                return (0, e.resolve)(t), e.promise;
            };
        },
        {
            "./_an-object": 22,
            "./_is-object": 55,
            "./_new-promise-capability": 68
        }
    ],
    84: [
        function(e, t, n) {
            t.exports = function(e, t) {
                return {
                    enumerable: !(1 & e),
                    configurable: !(2 & e),
                    writable: !(4 & e),
                    value: t
                };
            };
        },
        {}
    ],
    85: [
        function(e, t, n) {
            var r = e("./_redefine");
            t.exports = function(e, t, n) {
                for(var o in t)r(e, o, t[o], n);
                return e;
            };
        },
        {
            "./_redefine": 86
        }
    ],
    86: [
        function(e, t, n) {
            var i = e("./_global"), s = e("./_hide"), a = e("./_has"), c = e("./_uid")("src"), o = e("./_function-to-string"), r = "toString", u = ("" + o).split(r);
            e("./_core").inspectSource = function(e) {
                return o.call(e);
            }, (t.exports = function(e, t, n, o) {
                var r = "function" == typeof n;
                r && (a(n, "name") || s(n, "name", t)), e[t] !== n && (r && (a(n, c) || s(n, c, e[t] ? "" + e[t] : u.join(String(t)))), e === i ? e[t] = n : o ? e[t] ? e[t] = n : s(e, t, n) : (delete e[t], s(e, t, n)));
            })(Function.prototype, r, function() {
                return "function" == typeof this && this[c] || o.call(this);
            });
        },
        {
            "./_core": 31,
            "./_function-to-string": 44,
            "./_global": 45,
            "./_has": 46,
            "./_hide": 47,
            "./_uid": 108
        }
    ],
    87: [
        function(e, t, n) {
            "use strict";
            var o = e("./_classof"), r = RegExp.prototype.exec;
            t.exports = function(e, t) {
                var n = e.exec;
                if ("function" == typeof n) {
                    n = n.call(e, t);
                    if ("object" != typeof n) throw new TypeError("RegExp exec method returned something other than an Object or null");
                    return n;
                }
                if ("RegExp" !== o(e)) throw new TypeError("RegExp#exec called on incompatible receiver");
                return r.call(e, t);
            };
        },
        {
            "./_classof": 29
        }
    ],
    88: [
        function(e, t, n) {
            "use strict";
            var o, s = e("./_flags"), a = RegExp.prototype.exec, c = String.prototype.replace, r = a, u = "lastIndex", l = (o = /a/, e = /b*/g, a.call(o, "a"), a.call(e, "a"), 0 !== o[u] || 0 !== e[u]), f = void 0 !== /()??/.exec("")[1];
            t.exports = r = l || f ? function(e) {
                var t, n, o, r, i = this;
                return f && (n = new RegExp("^" + i.source + "$(?!\\s)", s.call(i))), l && (t = i[u]), o = a.call(i, e), l && o && (i[u] = i.global ? o.index + o[0].length : t), f && o && 1 < o.length && c.call(o[0], n, function() {
                    for(r = 1; r < arguments.length - 2; r++)void 0 === arguments[r] && (o[r] = void 0);
                }), o;
            } : r;
        },
        {
            "./_flags": 42
        }
    ],
    89: [
        function(t, e, n) {
            function r(e, t) {
                if (i(e), !o(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
            }
            var o = t("./_is-object"), i = t("./_an-object");
            e.exports = {
                set: Object.setPrototypeOf || ("__proto__" in {} ? function(e, n, o) {
                    try {
                        (o = t("./_ctx")(Function.call, t("./_object-gopd").f(Object.prototype, "__proto__").set, 2))(e, []), n = !(e instanceof Array);
                    } catch (e) {
                        n = !0;
                    }
                    return function(e, t) {
                        return r(e, t), n ? e.__proto__ = t : o(e, t), e;
                    };
                }({}, !1) : void 0),
                check: r
            };
        },
        {
            "./_an-object": 22,
            "./_ctx": 32,
            "./_is-object": 55,
            "./_object-gopd": 73
        }
    ],
    90: [
        function(e, t, n) {
            "use strict";
            var o = e("./_global"), r = e("./_object-dp"), i = e("./_descriptors"), s = e("./_wks")("species");
            t.exports = function(e) {
                e = o[e];
                i && e && !e[s] && r.f(e, s, {
                    configurable: !0,
                    get: function() {
                        return this;
                    }
                });
            };
        },
        {
            "./_descriptors": 34,
            "./_global": 45,
            "./_object-dp": 71,
            "./_wks": 112
        }
    ],
    91: [
        function(e, t, n) {
            var o = e("./_object-dp").f, r = e("./_has"), i = e("./_wks")("toStringTag");
            t.exports = function(e, t, n) {
                e && !r(e = n ? e : e.prototype, i) && o(e, i, {
                    configurable: !0,
                    value: t
                });
            };
        },
        {
            "./_has": 46,
            "./_object-dp": 71,
            "./_wks": 112
        }
    ],
    92: [
        function(e, t, n) {
            var o = e("./_shared")("keys"), r = e("./_uid");
            t.exports = function(e) {
                return o[e] || (o[e] = r(e));
            };
        },
        {
            "./_shared": 93,
            "./_uid": 108
        }
    ],
    93: [
        function(e, t, n) {
            var o = e("./_core"), r = e("./_global"), i = "__core-js_shared__", s = r[i] || (r[i] = {});
            (t.exports = function(e, t) {
                return s[e] || (s[e] = void 0 !== t ? t : {});
            })("versions", []).push({
                version: o.version,
                mode: e("./_library") ? "pure" : "global",
                copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
            });
        },
        {
            "./_core": 31,
            "./_global": 45,
            "./_library": 63
        }
    ],
    94: [
        function(e, t, n) {
            var o = e("./_an-object"), r = e("./_a-function"), i = e("./_wks")("species");
            t.exports = function(e, t) {
                var n, e = o(e).constructor;
                return void 0 === e || null == (n = o(e)[i]) ? t : r(n);
            };
        },
        {
            "./_a-function": 18,
            "./_an-object": 22,
            "./_wks": 112
        }
    ],
    95: [
        function(e, t, n) {
            var s = e("./_to-integer"), a = e("./_defined");
            t.exports = function(i) {
                return function(e, t) {
                    var n, o = String(a(e)), r = s(t), e = o.length;
                    return r < 0 || e <= r ? i ? "" : void 0 : (t = o.charCodeAt(r)) < 55296 || 56319 < t || r + 1 === e || (n = o.charCodeAt(r + 1)) < 56320 || 57343 < n ? i ? o.charAt(r) : t : i ? o.slice(r, r + 2) : n - 56320 + (t - 55296 << 10) + 65536;
                };
            };
        },
        {
            "./_defined": 33,
            "./_to-integer": 100
        }
    ],
    96: [
        function(e, t, n) {
            var o = e("./_is-regexp"), r = e("./_defined");
            t.exports = function(e, t, n) {
                if (o(t)) throw TypeError("String#" + n + " doesn't accept regex!");
                return String(r(e));
            };
        },
        {
            "./_defined": 33,
            "./_is-regexp": 56
        }
    ],
    97: [
        function(e, t, n) {
            function o() {
                var e, t = +this;
                b.hasOwnProperty(t) && (e = b[t], delete b[t], e());
            }
            function r(e) {
                o.call(e.data);
            }
            var i, s = e("./_ctx"), a = e("./_invoke"), c = e("./_html"), u = e("./_dom-create"), l = e("./_global"), f = l.process, d = l.setImmediate, p = l.clearImmediate, h = l.MessageChannel, _ = l.Dispatch, g = 0, b = {}, m = "onreadystatechange";
            d && p || (d = function(e) {
                for(var t = [], n = 1; n < arguments.length;)t.push(arguments[n++]);
                return b[++g] = function() {
                    a("function" == typeof e ? e : Function(e), t);
                }, i(g), g;
            }, p = function(e) {
                delete b[e];
            }, "process" == e("./_cof")(f) ? i = function(e) {
                f.nextTick(s(o, e, 1));
            } : _ && _.now ? i = function(e) {
                _.now(s(o, e, 1));
            } : h ? (h = (e = new h).port2, e.port1.onmessage = r, i = s(h.postMessage, h, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts ? (i = function(e) {
                l.postMessage(e + "", "*");
            }, l.addEventListener("message", r, !1)) : i = m in u("script") ? function(e) {
                c.appendChild(u("script"))[m] = function() {
                    c.removeChild(this), o.call(e);
                };
            } : function(e) {
                setTimeout(s(o, e, 1), 0);
            }), t.exports = {
                set: d,
                clear: p
            };
        },
        {
            "./_cof": 30,
            "./_ctx": 32,
            "./_dom-create": 35,
            "./_global": 45,
            "./_html": 48,
            "./_invoke": 51
        }
    ],
    98: [
        function(e, t, n) {
            var o = e("./_to-integer"), r = Math.max, i = Math.min;
            t.exports = function(e, t) {
                return (e = o(e)) < 0 ? r(e + t, 0) : i(e, t);
            };
        },
        {
            "./_to-integer": 100
        }
    ],
    99: [
        function(e, t, n) {
            var o = e("./_to-integer"), r = e("./_to-length");
            t.exports = function(e) {
                if (void 0 === e) return 0;
                var t = o(e), e = r(t);
                if (t !== e) throw RangeError("Wrong length!");
                return e;
            };
        },
        {
            "./_to-integer": 100,
            "./_to-length": 102
        }
    ],
    100: [
        function(e, t, n) {
            var o = Math.ceil, r = Math.floor;
            t.exports = function(e) {
                return isNaN(e = +e) ? 0 : (0 < e ? r : o)(e);
            };
        },
        {}
    ],
    101: [
        function(e, t, n) {
            var o = e("./_iobject"), r = e("./_defined");
            t.exports = function(e) {
                return o(r(e));
            };
        },
        {
            "./_defined": 33,
            "./_iobject": 52
        }
    ],
    102: [
        function(e, t, n) {
            var o = e("./_to-integer"), r = Math.min;
            t.exports = function(e) {
                return 0 < e ? r(o(e), 9007199254740991) : 0;
            };
        },
        {
            "./_to-integer": 100
        }
    ],
    103: [
        function(e, t, n) {
            var o = e("./_defined");
            t.exports = function(e) {
                return Object(o(e));
            };
        },
        {
            "./_defined": 33
        }
    ],
    104: [
        function(e, t, n) {
            var r = e("./_is-object");
            t.exports = function(e, t) {
                if (!r(e)) return e;
                var n, o;
                if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
                if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
                if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
                throw TypeError("Can't convert object to primitive value");
            };
        },
        {
            "./_is-object": 55
        }
    ],
    105: [
        function(e, t, n) {
            "use strict";
            var p, h, _, g, b, o, f, m, r, v, i, s, y, j, a, c, u, x, w, d, k, S, E, P, O, l, A, M, D, T, C, L, I, F, R, B, U, q, z, N, W, G, H, V, K, X, Y, Q, J, Z, $, ee, te, ne, oe, re, ie, se, ae, ce, ue, le, fe, de, pe, he, _e, ge, be, me, ve, ye, je, xe, we, ke, Se, Ee, Pe, Oe, Ae, Me, De, Te, Ce, Le, Ie, Fe, Re, Be, Ue, qe, ze;
            e("./_descriptors") ? (p = e("./_library"), h = e("./_global"), _ = e("./_fails"), g = e("./_export"), b = e("./_typed"), o = e("./_typed-buffer"), f = e("./_ctx"), m = e("./_an-instance"), r = e("./_property-desc"), v = e("./_hide"), i = e("./_redefine-all"), s = e("./_to-integer"), y = e("./_to-length"), j = e("./_to-index"), a = e("./_to-absolute-index"), c = e("./_to-primitive"), u = e("./_has"), x = e("./_classof"), w = e("./_is-object"), d = e("./_to-object"), k = e("./_is-array-iter"), S = e("./_object-create"), E = e("./_object-gpo"), P = e("./_object-gopn").f, O = e("./core.get-iterator-method"), Ue = e("./_uid"), Ae = e("./_wks"), qe = e("./_array-methods"), l = e("./_array-includes"), A = e("./_species-constructor"), M = e("./es6.array.iterator"), D = e("./_iterators"), T = e("./_iter-detect"), C = e("./_set-species"), L = e("./_array-fill"), I = e("./_array-copy-within"), F = e("./_object-dp"), R = e("./_object-gopd"), B = F.f, U = R.f, q = h.RangeError, z = h.TypeError, N = h.Uint8Array, G = "Shared" + (W = "ArrayBuffer"), H = "BYTES_PER_ELEMENT", V = "prototype", e = Array[V], K = o.ArrayBuffer, X = o.DataView, Y = qe(0), Q = qe(2), J = qe(3), Z = qe(4), $ = qe(5), ee = qe(6), te = l(!0), ne = l(!1), oe = M.values, re = M.keys, ie = M.entries, se = e.lastIndexOf, ae = e.reduce, ce = e.reduceRight, ue = e.join, le = e.sort, fe = e.slice, de = e.toString, pe = e.toLocaleString, he = Ae("iterator"), _e = Ae("toStringTag"), ge = Ue("typed_constructor"), be = Ue("def_constructor"), e = b.CONSTR, me = b.TYPED, ve = b.VIEW, ye = "Wrong length!", je = qe(1, function(e, t) {
                return Ee(A(e, e[be]), t);
            }), xe = _(function() {
                return 1 === new N(new Uint16Array([
                    1
                ]).buffer)[0];
            }), we = !!N && !!N[V].set && _(function() {
                new N(1).set({});
            }), ke = function(e, t) {
                e = s(e);
                if (e < 0 || e % t) throw q("Wrong offset!");
                return e;
            }, Se = function(e) {
                if (w(e) && me in e) return e;
                throw z(e + " is not a typed array!");
            }, Ee = function(e, t) {
                if (!(w(e) && ge in e)) throw z("It is not a typed array constructor!");
                return new e(t);
            }, Pe = function(e, t) {
                return Oe(A(e, e[be]), t);
            }, Oe = function(e, t) {
                for(var n = 0, o = t.length, r = Ee(e, o); n < o;)r[n] = t[n++];
                return r;
            }, Ae = function(e, t, n) {
                B(e, t, {
                    get: function() {
                        return this._d[n];
                    }
                });
            }, Me = function(e) {
                var t, n, o, r, i, s, a = d(e), c = arguments.length, u = 1 < c ? arguments[1] : void 0, l = void 0 !== u, e = O(a);
                if (null != e && !k(e)) {
                    for(s = e.call(a), o = [], t = 0; !(i = s.next()).done; t++)o.push(i.value);
                    a = o;
                }
                for(l && 2 < c && (u = f(u, arguments[2], 2)), t = 0, n = y(a.length), r = Ee(this, n); t < n; t++)r[t] = l ? u(a[t], t) : a[t];
                return r;
            }, De = function() {
                for(var e = 0, t = arguments.length, n = Ee(this, t); e < t;)n[e] = arguments[e++];
                return n;
            }, Te = !!N && _(function() {
                pe.call(new N(1));
            }), Ce = function() {
                return pe.apply(Te ? fe.call(Se(this)) : Se(this), arguments);
            }, Le = {
                copyWithin: function(e, t) {
                    return I.call(Se(this), e, t, 2 < arguments.length ? arguments[2] : void 0);
                },
                every: function(e) {
                    return Z(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                fill: function(e) {
                    return L.apply(Se(this), arguments);
                },
                filter: function(e) {
                    return Pe(this, Q(Se(this), e, 1 < arguments.length ? arguments[1] : void 0));
                },
                find: function(e) {
                    return $(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                findIndex: function(e) {
                    return ee(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                forEach: function(e) {
                    Y(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                indexOf: function(e) {
                    return ne(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                includes: function(e) {
                    return te(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                join: function(e) {
                    return ue.apply(Se(this), arguments);
                },
                lastIndexOf: function(e) {
                    return se.apply(Se(this), arguments);
                },
                map: function(e) {
                    return je(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                reduce: function(e) {
                    return ae.apply(Se(this), arguments);
                },
                reduceRight: function(e) {
                    return ce.apply(Se(this), arguments);
                },
                reverse: function() {
                    for(var e, t = this, n = Se(t).length, o = Math.floor(n / 2), r = 0; r < o;)e = t[r], t[r++] = t[--n], t[n] = e;
                    return t;
                },
                some: function(e) {
                    return J(Se(this), e, 1 < arguments.length ? arguments[1] : void 0);
                },
                sort: function(e) {
                    return le.call(Se(this), e);
                },
                subarray: function(e, t) {
                    var n = Se(this), o = n.length, e = a(e, o);
                    return new (A(n, n[be]))(n.buffer, n.byteOffset + e * n.BYTES_PER_ELEMENT, y((void 0 === t ? o : a(t, o)) - e));
                }
            }, Ie = function(e, t) {
                return Pe(this, fe.call(Se(this), e, t));
            }, Fe = function(e) {
                Se(this);
                var t = ke(arguments[1], 1), n = this.length, o = d(e), r = y(o.length), i = 0;
                if (n < r + t) throw q(ye);
                for(; i < r;)this[t + i] = o[i++];
            }, Re = {
                entries: function() {
                    return ie.call(Se(this));
                },
                keys: function() {
                    return re.call(Se(this));
                },
                values: function() {
                    return oe.call(Se(this));
                }
            }, Be = function(e, t) {
                return w(e) && e[me] && "symbol" != typeof t && t in e && String(+t) == String(t);
            }, Ue = function(e, t) {
                return Be(e, t = c(t, !0)) ? r(2, e[t]) : U(e, t);
            }, qe = function(e, t, n) {
                return !(Be(e, t = c(t, !0)) && w(n) && u(n, "value")) || u(n, "get") || u(n, "set") || n.configurable || u(n, "writable") && !n.writable || u(n, "enumerable") && !n.enumerable ? B(e, t, n) : (e[t] = n.value, e);
            }, e || (R.f = Ue, F.f = qe), g(g.S + g.F * !e, "Object", {
                getOwnPropertyDescriptor: Ue,
                defineProperty: qe
            }), _(function() {
                de.call({});
            }) && (de = pe = function() {
                return ue.call(this);
            }), ze = i({}, Le), i(ze, Re), v(ze, he, Re.values), i(ze, {
                slice: Ie,
                set: Fe,
                constructor: function() {},
                toString: de,
                toLocaleString: Ce
            }), Ae(ze, "buffer", "b"), Ae(ze, "byteOffset", "o"), Ae(ze, "byteLength", "l"), Ae(ze, "length", "e"), B(ze, _e, {
                get: function() {
                    return this[me];
                }
            }), t.exports = function(e, u, t, o) {
                function l(e, t) {
                    B(e, t, {
                        get: function() {
                            return function(e, t) {
                                e = e._d;
                                return e.v[n](t * u + e.o, xe);
                            }(this, t);
                        },
                        set: function(e) {
                            return function(e, t, n) {
                                e = e._d;
                                o && (n = (n = Math.round(n)) < 0 ? 0 : 255 < n ? 255 : 255 & n), e.v[r](t * u + e.o, n, xe);
                            }(this, t, e);
                        },
                        enumerable: !0
                    });
                }
                var f = e + ((o = !!o) ? "Clamped" : "") + "Array", n = "get" + e, r = "set" + e, d = h[f], i = d || {}, s = d && E(d), a = !d || !b.ABV, e = {}, c = d && d[V];
                a ? (d = t(function(e, t, n, o) {
                    m(e, d, f, "_d");
                    var r, i, s = 0, a = 0;
                    if (w(t)) {
                        if (!(t instanceof K || (c = x(t)) == W || c == G)) return me in t ? Oe(d, t) : Me.call(d, t);
                        var c = t, a = ke(n, u), n = t.byteLength;
                        if (void 0 === o) {
                            if (n % u) throw q(ye);
                            if ((r = n - a) < 0) throw q(ye);
                        } else if (n < (r = y(o) * u) + a) throw q(ye);
                        i = r / u;
                    } else i = j(t), c = new K(r = i * u);
                    for(v(e, "_d", {
                        b: c,
                        o: a,
                        l: r,
                        e: i,
                        v: new X(c)
                    }); s < i;)l(e, s++);
                }), c = d[V] = S(ze), v(c, "constructor", d)) : _(function() {
                    d(1);
                }) && _(function() {
                    new d(-1);
                }) && T(function(e) {
                    new d, new d(null), new d(1.5), new d(e);
                }, !0) || (d = t(function(e, t, n, o) {
                    var r;
                    return m(e, d, f), w(t) ? t instanceof K || (r = x(t)) == W || r == G ? void 0 !== o ? new i(t, ke(n, u), o) : void 0 !== n ? new i(t, ke(n, u)) : new i(t) : me in t ? Oe(d, t) : Me.call(d, t) : new i(j(t));
                }), Y(s !== Function.prototype ? P(i).concat(P(s)) : P(i), function(e) {
                    e in d || v(d, e, i[e]);
                }), d[V] = c, p || (c.constructor = d));
                a = c[he], t = !!a && ("values" == a.name || null == a.name), s = Re.values;
                v(d, ge, !0), v(c, me, f), v(c, ve, !0), v(c, be, d), (o ? new d(1)[_e] == f : _e in c) || B(c, _e, {
                    get: function() {
                        return f;
                    }
                }), e[f] = d, g(g.G + g.W + g.F * (d != i), e), g(g.S, f, {
                    BYTES_PER_ELEMENT: u
                }), g(g.S + g.F * _(function() {
                    i.of.call(d, 1);
                }), f, {
                    from: Me,
                    of: De
                }), H in c || v(c, H, u), g(g.P, f, Le), C(f), g(g.P + g.F * we, f, {
                    set: Fe
                }), g(g.P + g.F * !t, f, Re), p || c.toString == de || (c.toString = de), g(g.P + g.F * _(function() {
                    new d(1).slice();
                }), f, {
                    slice: Ie
                }), g(g.P + g.F * (_(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new d([
                        1,
                        2
                    ]).toLocaleString();
                }) || !_(function() {
                    c.toLocaleString.call([
                        1,
                        2
                    ]);
                })), f, {
                    toLocaleString: Ce
                }), D[f] = t ? a : s, p || t || v(c, he, s);
            }) : t.exports = function() {};
        },
        {
            "./_an-instance": 21,
            "./_array-copy-within": 23,
            "./_array-fill": 24,
            "./_array-includes": 25,
            "./_array-methods": 26,
            "./_classof": 29,
            "./_ctx": 32,
            "./_descriptors": 34,
            "./_export": 38,
            "./_fails": 40,
            "./_global": 45,
            "./_has": 46,
            "./_hide": 47,
            "./_is-array-iter": 53,
            "./_is-object": 55,
            "./_iter-detect": 60,
            "./_iterators": 62,
            "./_library": 63,
            "./_object-create": 70,
            "./_object-dp": 71,
            "./_object-gopd": 73,
            "./_object-gopn": 75,
            "./_object-gpo": 77,
            "./_property-desc": 84,
            "./_redefine-all": 85,
            "./_set-species": 90,
            "./_species-constructor": 94,
            "./_to-absolute-index": 98,
            "./_to-index": 99,
            "./_to-integer": 100,
            "./_to-length": 102,
            "./_to-object": 103,
            "./_to-primitive": 104,
            "./_typed": 107,
            "./_typed-buffer": 106,
            "./_uid": 108,
            "./_wks": 112,
            "./core.get-iterator-method": 113,
            "./es6.array.iterator": 115
        }
    ],
    106: [
        function(e, t, n) {
            "use strict";
            var o = e("./_global"), r = e("./_descriptors"), i = e("./_library"), s = e("./_typed"), a = e("./_hide"), c = e("./_redefine-all"), u = e("./_fails"), l = e("./_an-instance"), f = e("./_to-integer"), d = e("./_to-length"), p = e("./_to-index"), h = e("./_object-gopn").f, _ = e("./_object-dp").f, g = e("./_array-fill"), b = e("./_set-to-string-tag"), m = "ArrayBuffer", v = "DataView", y = "prototype", j = "Wrong index!", x = o[m], w = o[v], e = o.Math, k = o.RangeError, S = o.Infinity, E = x, P = e.abs, O = e.pow, A = e.floor, M = e.log, D = e.LN2, o = "byteLength", e = "byteOffset", T = r ? "_b" : "buffer", C = r ? "_l" : o, L = r ? "_o" : e;
            function I(e, t, n) {
                var o, r, i = new Array(n), s = 8 * n - t - 1, a = (1 << s) - 1, c = a >> 1, u = 23 === t ? O(2, -24) - O(2, -77) : 0, l = 0, f = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                for((e = P(e)) != e || e === S ? (r = e != e ? 1 : 0, o = a) : (o = A(M(e) / D), e * (n = O(2, -o)) < 1 && (o--, n *= 2), 2 <= (e += 1 <= o + c ? u / n : u * O(2, 1 - c)) * n && (o++, n /= 2), a <= o + c ? (r = 0, o = a) : 1 <= o + c ? (r = (e * n - 1) * O(2, t), o += c) : (r = e * O(2, c - 1) * O(2, t), o = 0)); 8 <= t; i[l++] = 255 & r, r /= 256, t -= 8);
                for(o = o << t | r, s += t; 0 < s; i[l++] = 255 & o, o /= 256, s -= 8);
                return i[--l] |= 128 * f, i;
            }
            function F(e, t, n) {
                var o, r = 8 * n - t - 1, i = (1 << r) - 1, s = i >> 1, a = r - 7, c = n - 1, n = e[c--], u = 127 & n;
                for(n >>= 7; 0 < a; u = 256 * u + e[c], c--, a -= 8);
                for(o = u & (1 << -a) - 1, u >>= -a, a += t; 0 < a; o = 256 * o + e[c], c--, a -= 8);
                if (0 === u) u = 1 - s;
                else {
                    if (u === i) return o ? NaN : n ? -S : S;
                    o += O(2, t), u -= s;
                }
                return (n ? -1 : 1) * o * O(2, u - t);
            }
            function R(e) {
                return e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0];
            }
            function B(e) {
                return [
                    255 & e
                ];
            }
            function U(e) {
                return [
                    255 & e,
                    e >> 8 & 255
                ];
            }
            function q(e) {
                return [
                    255 & e,
                    e >> 8 & 255,
                    e >> 16 & 255,
                    e >> 24 & 255
                ];
            }
            function z(e) {
                return I(e, 52, 8);
            }
            function N(e) {
                return I(e, 23, 4);
            }
            function W(e, t, n) {
                _(e[y], t, {
                    get: function() {
                        return this[n];
                    }
                });
            }
            function G(e, t, n, o) {
                var r = p(+n);
                if (r + t > e[C]) throw k(j);
                n = e[T]._b, e = r + e[L], t = n.slice(e, e + t);
                return o ? t : t.reverse();
            }
            function H(e, t, n, o, r, i) {
                n = p(+n);
                if (n + t > e[C]) throw k(j);
                for(var s = e[T]._b, a = n + e[L], c = o(+r), u = 0; u < t; u++)s[a + u] = c[i ? u : t - u - 1];
            }
            if (s.ABV) {
                if (!u(function() {
                    x(1);
                }) || !u(function() {
                    new x(-1);
                }) || u(function() {
                    return new x, new x(1.5), new x(NaN), x.name != m;
                })) {
                    for(var V, K = (x = function(e) {
                        return l(this, x), new E(p(e));
                    })[y] = E[y], X = h(E), Y = 0; X.length > Y;)(V = X[Y++]) in x || a(x, V, E[V]);
                    i || (K.constructor = x);
                }
                var K = new w(new x(2)), Q = w[y].setInt8;
                K.setInt8(0, 2147483648), K.setInt8(1, 2147483649), !K.getInt8(0) && K.getInt8(1) || c(w[y], {
                    setInt8: function(e, t) {
                        Q.call(this, e, t << 24 >> 24);
                    },
                    setUint8: function(e, t) {
                        Q.call(this, e, t << 24 >> 24);
                    }
                }, !0);
            } else x = function(e) {
                l(this, x, m);
                e = p(e);
                this._b = g.call(new Array(e), 0), this[C] = e;
            }, w = function(e, t, n) {
                l(this, w, v), l(e, x, v);
                var o = e[C], t = f(t);
                if (t < 0 || o < t) throw k("Wrong offset!");
                if (o < t + (n = void 0 === n ? o - t : d(n))) throw k("Wrong length!");
                this[T] = e, this[L] = t, this[C] = n;
            }, r && (W(x, o, "_l"), W(w, "buffer", "_b"), W(w, o, "_l"), W(w, e, "_o")), c(w[y], {
                getInt8: function(e) {
                    return G(this, 1, e)[0] << 24 >> 24;
                },
                getUint8: function(e) {
                    return G(this, 1, e)[0];
                },
                getInt16: function(e) {
                    e = G(this, 2, e, arguments[1]);
                    return (e[1] << 8 | e[0]) << 16 >> 16;
                },
                getUint16: function(e) {
                    e = G(this, 2, e, arguments[1]);
                    return e[1] << 8 | e[0];
                },
                getInt32: function(e) {
                    return R(G(this, 4, e, arguments[1]));
                },
                getUint32: function(e) {
                    return R(G(this, 4, e, arguments[1])) >>> 0;
                },
                getFloat32: function(e) {
                    return F(G(this, 4, e, arguments[1]), 23, 4);
                },
                getFloat64: function(e) {
                    return F(G(this, 8, e, arguments[1]), 52, 8);
                },
                setInt8: function(e, t) {
                    H(this, 1, e, B, t);
                },
                setUint8: function(e, t) {
                    H(this, 1, e, B, t);
                },
                setInt16: function(e, t) {
                    H(this, 2, e, U, t, arguments[2]);
                },
                setUint16: function(e, t) {
                    H(this, 2, e, U, t, arguments[2]);
                },
                setInt32: function(e, t) {
                    H(this, 4, e, q, t, arguments[2]);
                },
                setUint32: function(e, t) {
                    H(this, 4, e, q, t, arguments[2]);
                },
                setFloat32: function(e, t) {
                    H(this, 4, e, N, t, arguments[2]);
                },
                setFloat64: function(e, t) {
                    H(this, 8, e, z, t, arguments[2]);
                }
            });
            b(x, m), b(w, v), a(w[y], s.VIEW, !0), n[m] = x, n[v] = w;
        },
        {
            "./_an-instance": 21,
            "./_array-fill": 24,
            "./_descriptors": 34,
            "./_fails": 40,
            "./_global": 45,
            "./_hide": 47,
            "./_library": 63,
            "./_object-dp": 71,
            "./_object-gopn": 75,
            "./_redefine-all": 85,
            "./_set-to-string-tag": 91,
            "./_to-index": 99,
            "./_to-integer": 100,
            "./_to-length": 102,
            "./_typed": 107
        }
    ],
    107: [
        function(e, t, n) {
            for(var o, r = e("./_global"), i = e("./_hide"), e = e("./_uid"), s = e("typed_array"), a = e("view"), e = !(!r.ArrayBuffer || !r.DataView), c = e, u = 0, l = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); u < 9;)(o = r[l[u++]]) ? (i(o.prototype, s, !0), i(o.prototype, a, !0)) : c = !1;
            t.exports = {
                ABV: e,
                CONSTR: c,
                TYPED: s,
                VIEW: a
            };
        },
        {
            "./_global": 45,
            "./_hide": 47,
            "./_uid": 108
        }
    ],
    108: [
        function(e, t, n) {
            var o = 0, r = Math.random();
            t.exports = function(e) {
                return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++o + r).toString(36));
            };
        },
        {}
    ],
    109: [
        function(e, t, n) {
            e = e("./_global").navigator;
            t.exports = e && e.userAgent || "";
        },
        {
            "./_global": 45
        }
    ],
    110: [
        function(e, t, n) {
            var o = e("./_global"), r = e("./_core"), i = e("./_library"), s = e("./_wks-ext"), a = e("./_object-dp").f;
            t.exports = function(e) {
                var t = r.Symbol || (r.Symbol = !i && o.Symbol || {});
                "_" == e.charAt(0) || e in t || a(t, e, {
                    value: s.f(e)
                });
            };
        },
        {
            "./_core": 31,
            "./_global": 45,
            "./_library": 63,
            "./_object-dp": 71,
            "./_wks-ext": 111
        }
    ],
    111: [
        function(e, t, n) {
            n.f = e("./_wks");
        },
        {
            "./_wks": 112
        }
    ],
    112: [
        function(e, t, n) {
            var o = e("./_shared")("wks"), r = e("./_uid"), i = e("./_global").Symbol, s = "function" == typeof i;
            (t.exports = function(e) {
                return o[e] || (o[e] = s && i[e] || (s ? i : r)("Symbol." + e));
            }).store = o;
        },
        {
            "./_global": 45,
            "./_shared": 93,
            "./_uid": 108
        }
    ],
    113: [
        function(e, t, n) {
            var o = e("./_classof"), r = e("./_wks")("iterator"), i = e("./_iterators");
            t.exports = e("./_core").getIteratorMethod = function(e) {
                if (null != e) return e[r] || e["@@iterator"] || i[o(e)];
            };
        },
        {
            "./_classof": 29,
            "./_core": 31,
            "./_iterators": 62,
            "./_wks": 112
        }
    ],
    114: [
        function(e, t, n) {
            "use strict";
            var o = e("./_export"), r = e("./_array-methods")(6), i = "findIndex", s = !0;
            i in [] && Array(1)[i](function() {
                s = !1;
            }), o(o.P + o.F * s, "Array", {
                findIndex: function(e) {
                    return r(this, e, 1 < arguments.length ? arguments[1] : void 0);
                }
            }), e("./_add-to-unscopables")(i);
        },
        {
            "./_add-to-unscopables": 19,
            "./_array-methods": 26,
            "./_export": 38
        }
    ],
    115: [
        function(e, t, n) {
            "use strict";
            var o = e("./_add-to-unscopables"), r = e("./_iter-step"), i = e("./_iterators"), s = e("./_to-iobject");
            t.exports = e("./_iter-define")(Array, "Array", function(e, t) {
                this._t = s(e), this._i = 0, this._k = t;
            }, function() {
                var e = this._t, t = this._k, n = this._i++;
                return !e || n >= e.length ? (this._t = void 0, r(1)) : r(0, "keys" == t ? n : "values" == t ? e[n] : [
                    n,
                    e[n]
                ]);
            }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
        },
        {
            "./_add-to-unscopables": 19,
            "./_iter-define": 59,
            "./_iter-step": 61,
            "./_iterators": 62,
            "./_to-iobject": 101
        }
    ],
    116: [
        function(e, t, n) {
            var o = e("./_object-dp").f, r = Function.prototype, i = /^\s*function ([^ (]*)/;
            "name" in r || e("./_descriptors") && o(r, "name", {
                configurable: !0,
                get: function() {
                    try {
                        return ("" + this).match(i)[1];
                    } catch (e) {
                        return "";
                    }
                }
            });
        },
        {
            "./_descriptors": 34,
            "./_object-dp": 71
        }
    ],
    117: [
        function(e, t, n) {
            e = e("./_export");
            e(e.S, "Math", {
                clz32: function(e) {
                    return (e >>>= 0) ? 31 - Math.floor(Math.log(e + .5) * Math.LOG2E) : 32;
                }
            });
        },
        {
            "./_export": 38
        }
    ],
    118: [
        function(e, t, n) {
            var o = e("./_export");
            o(o.S, "Math", {
                fround: e("./_math-fround")
            });
        },
        {
            "./_export": 38,
            "./_math-fround": 64
        }
    ],
    119: [
        function(e, t, n) {
            var o = e("./_export"), r = Math.imul;
            o(o.S + o.F * e("./_fails")(function() {
                return -5 != r(4294967295, 5) || 2 != r.length;
            }), "Math", {
                imul: function(e, t) {
                    var n = 65535, o = +e, r = +t, e = n & o, t = n & r;
                    return 0 | e * t + ((n & o >>> 16) * t + e * (n & r >>> 16) << 16 >>> 0);
                }
            });
        },
        {
            "./_export": 38,
            "./_fails": 40
        }
    ],
    120: [
        function(e, t, n) {
            e = e("./_export");
            e(e.S, "Math", {
                trunc: function(e) {
                    return (0 < e ? Math.floor : Math.ceil)(e);
                }
            });
        },
        {
            "./_export": 38
        }
    ],
    121: [
        function(e, t, n) {
            var o = e("./_export");
            o(o.S + o.F, "Object", {
                assign: e("./_object-assign")
            });
        },
        {
            "./_export": 38,
            "./_object-assign": 69
        }
    ],
    122: [
        function(e, t, n) {
            var o = e("./_to-object"), r = e("./_object-keys");
            e("./_object-sap")("keys", function() {
                return function(e) {
                    return r(o(e));
                };
            });
        },
        {
            "./_object-keys": 79,
            "./_object-sap": 81,
            "./_to-object": 103
        }
    ],
    123: [
        function(e, t, n) {
            "use strict";
            var o = e("./_classof"), r = {};
            r[e("./_wks")("toStringTag")] = "z", r + "" != "[object z]" && e("./_redefine")(Object.prototype, "toString", function() {
                return "[object " + o(this) + "]";
            }, !0);
        },
        {
            "./_classof": 29,
            "./_redefine": 86,
            "./_wks": 112
        }
    ],
    124: [
        function(n, e, t) {
            "use strict";
            function o() {}
            function f(e) {
                var t;
                return !(!g(e) || "function" != typeof (t = e.then)) && t;
            }
            function r(l, t) {
                var n;
                l._n || (l._n = !0, n = l._c, x(function() {
                    for(var c = l._v, u = 1 == l._s, e = 0; n.length > e;)!function(e) {
                        var t, n, o, r = u ? e.ok : e.fail, i = e.resolve, s = e.reject, a = e.domain;
                        try {
                            r ? (u || (2 == l._h && R(l), l._h = 1), !0 === r ? t = c : (a && a.enter(), t = r(c), a && (a.exit(), o = !0)), t === e.promise ? s(O("Promise-chain cycle")) : (n = f(t)) ? n.call(t, i, s) : i(t)) : s(c);
                        } catch (e) {
                            a && !o && a.exit(), s(e);
                        }
                    }(n[e++]);
                    l._c = [], l._n = !1, t && !l._h && I(l);
                }));
            }
            function i(e) {
                var t = this;
                t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), r(t, !0));
            }
            var s, a, c, u, l = n("./_library"), d = n("./_global"), p = n("./_ctx"), h = n("./_classof"), _ = n("./_export"), g = n("./_is-object"), b = n("./_a-function"), m = n("./_an-instance"), v = n("./_for-of"), y = n("./_species-constructor"), j = n("./_task").set, x = n("./_microtask")(), w = n("./_new-promise-capability"), k = n("./_perform"), S = n("./_user-agent"), E = n("./_promise-resolve"), P = "Promise", O = d.TypeError, A = d.process, M = A && A.versions, D = M && M.v8 || "", T = d[P], C = "process" == h(A), L = a = w.f, h = !!function() {
                try {
                    var e = T.resolve(1), t = (e.constructor = {})[n("./_wks")("species")] = function(e) {
                        e(o, o);
                    };
                    return (C || "function" == typeof PromiseRejectionEvent) && e.then(o) instanceof t && 0 !== D.indexOf("6.6") && -1 === S.indexOf("Chrome/66");
                } catch (e) {}
            }(), I = function(r) {
                j.call(d, function() {
                    var e, t, n = r._v, o = F(r);
                    if (o && (e = k(function() {
                        C ? A.emit("unhandledRejection", n, r) : (t = d.onunhandledrejection) ? t({
                            promise: r,
                            reason: n
                        }) : (t = d.console) && t.error && t.error("Unhandled promise rejection", n);
                    }), r._h = C || F(r) ? 2 : 1), r._a = void 0, o && e.e) throw e.v;
                });
            }, F = function(e) {
                return 1 !== e._h && 0 === (e._a || e._c).length;
            }, R = function(t) {
                j.call(d, function() {
                    var e;
                    C ? A.emit("rejectionHandled", t) : (e = d.onrejectionhandled) && e({
                        promise: t,
                        reason: t._v
                    });
                });
            }, B = function(e) {
                var n, o = this;
                if (!o._d) {
                    o._d = !0, o = o._w || o;
                    try {
                        if (o === e) throw O("Promise can't be resolved itself");
                        (n = f(e)) ? x(function() {
                            var t = {
                                _w: o,
                                _d: !1
                            };
                            try {
                                n.call(e, p(B, t, 1), p(i, t, 1));
                            } catch (e) {
                                i.call(t, e);
                            }
                        }) : (o._v = e, o._s = 1, r(o, !1));
                    } catch (e) {
                        i.call({
                            _w: o,
                            _d: !1
                        }, e);
                    }
                }
            };
            h || (T = function(e) {
                m(this, T, P, "_h"), b(e), s.call(this);
                try {
                    e(p(B, this, 1), p(i, this, 1));
                } catch (e) {
                    i.call(this, e);
                }
            }, (s = function(e) {
                this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
            }).prototype = n("./_redefine-all")(T.prototype, {
                then: function(e, t) {
                    var n = L(y(this, T));
                    return n.ok = "function" != typeof e || e, n.fail = "function" == typeof t && t, n.domain = C ? A.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && r(this, !1), n.promise;
                },
                catch: function(e) {
                    return this.then(void 0, e);
                }
            }), c = function() {
                var e = new s;
                this.promise = e, this.resolve = p(B, e, 1), this.reject = p(i, e, 1);
            }, w.f = L = function(e) {
                return e === T || e === u ? new c : a(e);
            }), _(_.G + _.W + _.F * !h, {
                Promise: T
            }), n("./_set-to-string-tag")(T, P), n("./_set-species")(P), u = n("./_core")[P], _(_.S + _.F * !h, P, {
                reject: function(e) {
                    var t = L(this);
                    return (0, t.reject)(e), t.promise;
                }
            }), _(_.S + _.F * (l || !h), P, {
                resolve: function(e) {
                    return E(l && this === u ? T : this, e);
                }
            }), _(_.S + _.F * !(h && n("./_iter-detect")(function(e) {
                T.all(e).catch(o);
            })), P, {
                all: function(e) {
                    var s = this, t = L(s), a = t.resolve, c = t.reject, n = k(function() {
                        var o = [], r = 0, i = 1;
                        v(e, !1, function(e) {
                            var t = r++, n = !1;
                            o.push(void 0), i++, s.resolve(e).then(function(e) {
                                n || (n = !0, o[t] = e, --i || a(o));
                            }, c);
                        }), --i || a(o);
                    });
                    return n.e && c(n.v), t.promise;
                },
                race: function(e) {
                    var t = this, n = L(t), o = n.reject, r = k(function() {
                        v(e, !1, function(e) {
                            t.resolve(e).then(n.resolve, o);
                        });
                    });
                    return r.e && o(r.v), n.promise;
                }
            });
        },
        {
            "./_a-function": 18,
            "./_an-instance": 21,
            "./_classof": 29,
            "./_core": 31,
            "./_ctx": 32,
            "./_export": 38,
            "./_for-of": 43,
            "./_global": 45,
            "./_is-object": 55,
            "./_iter-detect": 60,
            "./_library": 63,
            "./_microtask": 67,
            "./_new-promise-capability": 68,
            "./_perform": 82,
            "./_promise-resolve": 83,
            "./_redefine-all": 85,
            "./_set-species": 90,
            "./_set-to-string-tag": 91,
            "./_species-constructor": 94,
            "./_task": 97,
            "./_user-agent": 109,
            "./_wks": 112
        }
    ],
    125: [
        function(e, t, n) {
            var o = e("./_global"), i = e("./_inherit-if-required"), r = e("./_object-dp").f, s = e("./_object-gopn").f, a = e("./_is-regexp"), c = e("./_flags"), u = h = o.RegExp, l = h.prototype, f = /a/g, d = /a/g, p = new h(f) !== f;
            if (e("./_descriptors") && (!p || e("./_fails")(function() {
                return d[e("./_wks")("match")] = !1, h(f) != f || h(d) == d || "/a/i" != h(f, "i");
            }))) {
                for(var h = function(e, t) {
                    var n = this instanceof h, o = a(e), r = void 0 === t;
                    return !n && o && e.constructor === h && r ? e : i(p ? new u(o && !r ? e.source : e, t) : u((o = e instanceof h) ? e.source : e, o && r ? c.call(e) : t), n ? this : l, h);
                }, _ = s(u), g = 0; _.length > g;)!function(t) {
                    t in h || r(h, t, {
                        configurable: !0,
                        get: function() {
                            return u[t];
                        },
                        set: function(e) {
                            u[t] = e;
                        }
                    });
                }(_[g++]);
                (l.constructor = h).prototype = l, e("./_redefine")(o, "RegExp", h);
            }
            e("./_set-species")("RegExp");
        },
        {
            "./_descriptors": 34,
            "./_fails": 40,
            "./_flags": 42,
            "./_global": 45,
            "./_inherit-if-required": 50,
            "./_is-regexp": 56,
            "./_object-dp": 71,
            "./_object-gopn": 75,
            "./_redefine": 86,
            "./_set-species": 90,
            "./_wks": 112
        }
    ],
    126: [
        function(e, t, n) {
            "use strict";
            var o = e("./_regexp-exec");
            e("./_export")({
                target: "RegExp",
                proto: !0,
                forced: o !== /./.exec
            }, {
                exec: o
            });
        },
        {
            "./_export": 38,
            "./_regexp-exec": 88
        }
    ],
    127: [
        function(e, t, n) {
            e("./_descriptors") && "g" != /./g.flags && e("./_object-dp").f(RegExp.prototype, "flags", {
                configurable: !0,
                get: e("./_flags")
            });
        },
        {
            "./_descriptors": 34,
            "./_flags": 42,
            "./_object-dp": 71
        }
    ],
    128: [
        function(e, t, n) {
            "use strict";
            var x = e("./_an-object"), w = e("./_to-object"), k = e("./_to-length"), S = e("./_to-integer"), E = e("./_advance-string-index"), P = e("./_regexp-exec-abstract"), O = Math.max, A = Math.min, M = Math.floor, D = /\$([$&`']|\d\d?|<[^>]*>)/g, T = /\$([$&`']|\d\d?)/g;
            e("./_fix-re-wks")("replace", 2, function(r, i, y, j) {
                return [
                    function(e, t) {
                        var n = r(this), o = null == e ? void 0 : e[i];
                        return void 0 !== o ? o.call(e, n, t) : y.call(String(n), e, t);
                    },
                    function(e, t) {
                        var n = j(y, e, this, t);
                        if (n.done) return n.value;
                        var o = x(e), r = String(this), i = "function" == typeof t;
                        i || (t = String(t));
                        var s, a = o.global;
                        a && (s = o.unicode, o.lastIndex = 0);
                        for(var c = [];;){
                            var u = P(o, r);
                            if (null === u) break;
                            if (c.push(u), !a) break;
                            "" === String(u[0]) && (o.lastIndex = E(r, k(o.lastIndex), s));
                        }
                        for(var l, f = "", d = 0, p = 0; p < c.length; p++){
                            for(var u = c[p], h = String(u[0]), _ = O(A(S(u.index), r.length), 0), g = [], b = 1; b < u.length; b++)g.push(void 0 === (l = u[b]) ? l : String(l));
                            var m, v = u.groups, v = i ? (m = [
                                h
                            ].concat(g, _, r), void 0 !== v && m.push(v), String(t.apply(void 0, m))) : function(i, s, a, c, u, e) {
                                var l = a + i.length, f = c.length, t = T;
                                void 0 !== u && (u = w(u), t = D);
                                return y.call(e, t, function(e, t) {
                                    var n;
                                    switch(t.charAt(0)){
                                        case "$":
                                            return "$";
                                        case "&":
                                            return i;
                                        case "`":
                                            return s.slice(0, a);
                                        case "'":
                                            return s.slice(l);
                                        case "<":
                                            n = u[t.slice(1, -1)];
                                            break;
                                        default:
                                            var o = +t;
                                            if (0 == o) return e;
                                            if (f < o) {
                                                var r = M(o / 10);
                                                return 0 === r ? e : r <= f ? void 0 === c[r - 1] ? t.charAt(1) : c[r - 1] + t.charAt(1) : e;
                                            }
                                            n = c[o - 1];
                                    }
                                    return void 0 === n ? "" : n;
                                });
                            }(h, r, _, g, v, t);
                            d <= _ && (f += r.slice(d, _) + v, d = _ + h.length);
                        }
                        return f + r.slice(d);
                    }
                ];
            });
        },
        {
            "./_advance-string-index": 20,
            "./_an-object": 22,
            "./_fix-re-wks": 41,
            "./_regexp-exec-abstract": 87,
            "./_to-integer": 100,
            "./_to-length": 102,
            "./_to-object": 103
        }
    ],
    129: [
        function(e, t, n) {
            "use strict";
            var f = e("./_is-regexp"), b = e("./_an-object"), m = e("./_species-constructor"), v = e("./_advance-string-index"), y = e("./_to-length"), j = e("./_regexp-exec-abstract"), d = e("./_regexp-exec"), o = e("./_fails"), x = Math.min, p = [].push, s = "split", w = "length", k = "lastIndex", S = 4294967295, E = !o(function() {
                RegExp(S, "y");
            });
            e("./_fix-re-wks")("split", 2, function(r, i, h, _) {
                var g = "c" == "abbc"[s](/(b)*/)[1] || 4 != "test"[s](/(?:)/, -1)[w] || 2 != "ab"[s](/(?:ab)*/)[w] || 4 != "."[s](/(.?)(.?)/)[w] || 1 < "."[s](/()()/)[w] || ""[s](/.?/)[w] ? function(e, t) {
                    var n = String(this);
                    if (void 0 === e && 0 === t) return [];
                    if (!f(e)) return h.call(n, e, t);
                    for(var o, r, i, s = [], a = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), c = 0, u = void 0 === t ? S : t >>> 0, l = new RegExp(e.source, a + "g"); (o = d.call(l, n)) && !(c < (r = l[k]) && (s.push(n.slice(c, o.index)), 1 < o[w] && o.index < n[w] && p.apply(s, o.slice(1)), i = o[0][w], c = r, s[w] >= u));)l[k] === o.index && l[k]++;
                    return c === n[w] ? !i && l.test("") || s.push("") : s.push(n.slice(c)), s[w] > u ? s.slice(0, u) : s;
                } : "0"[s](void 0, 0)[w] ? function(e, t) {
                    return void 0 === e && 0 === t ? [] : h.call(this, e, t);
                } : h;
                return [
                    function(e, t) {
                        var n = r(this), o = null == e ? void 0 : e[i];
                        return void 0 !== o ? o.call(e, n, t) : g.call(String(n), e, t);
                    },
                    function(e, t) {
                        var n = _(g, e, this, t, g !== h);
                        if (n.done) return n.value;
                        var o = b(e), r = String(this), n = m(o, RegExp), i = o.unicode, e = (o.ignoreCase ? "i" : "") + (o.multiline ? "m" : "") + (o.unicode ? "u" : "") + (E ? "y" : "g"), s = new n(E ? o : "^(?:" + o.source + ")", e), a = void 0 === t ? S : t >>> 0;
                        if (0 == a) return [];
                        if (0 === r.length) return null === j(s, r) ? [
                            r
                        ] : [];
                        for(var c = 0, u = 0, l = []; u < r.length;){
                            s.lastIndex = E ? u : 0;
                            var f, d = j(s, E ? r : r.slice(u));
                            if (null === d || (f = x(y(s.lastIndex + (E ? 0 : u)), r.length)) === c) u = v(r, u, i);
                            else {
                                if (l.push(r.slice(c, u)), l.length === a) return l;
                                for(var p = 1; p <= d.length - 1; p++)if (l.push(d[p]), l.length === a) return l;
                                u = c = f;
                            }
                        }
                        return l.push(r.slice(c)), l;
                    }
                ];
            });
        },
        {
            "./_advance-string-index": 20,
            "./_an-object": 22,
            "./_fails": 40,
            "./_fix-re-wks": 41,
            "./_is-regexp": 56,
            "./_regexp-exec": 88,
            "./_regexp-exec-abstract": 87,
            "./_species-constructor": 94,
            "./_to-length": 102
        }
    ],
    130: [
        function(t, e, n) {
            "use strict";
            t("./es6.regexp.flags");
            function o(e) {
                t("./_redefine")(RegExp.prototype, a, e, !0);
            }
            var r = t("./_an-object"), i = t("./_flags"), s = t("./_descriptors"), a = "toString", c = /./[a];
            t("./_fails")(function() {
                return "/a/b" != c.call({
                    source: "a",
                    flags: "b"
                });
            }) ? o(function() {
                var e = r(this);
                return "/".concat(e.source, "/", "flags" in e ? e.flags : !s && e instanceof RegExp ? i.call(e) : void 0);
            }) : c.name != a && o(function() {
                return c.call(this);
            });
        },
        {
            "./_an-object": 22,
            "./_descriptors": 34,
            "./_fails": 40,
            "./_flags": 42,
            "./_redefine": 86,
            "./es6.regexp.flags": 127
        }
    ],
    131: [
        function(e, t, n) {
            "use strict";
            var o = e("./_export"), r = e("./_to-length"), i = e("./_string-context"), s = "endsWith", a = ""[s];
            o(o.P + o.F * e("./_fails-is-regexp")(s), "String", {
                endsWith: function(e) {
                    var t = i(this, e, s), n = 1 < arguments.length ? arguments[1] : void 0, o = r(t.length), o = void 0 === n ? o : Math.min(r(n), o), e = String(e);
                    return a ? a.call(t, e, o) : t.slice(o - e.length, o) === e;
                }
            });
        },
        {
            "./_export": 38,
            "./_fails-is-regexp": 39,
            "./_string-context": 96,
            "./_to-length": 102
        }
    ],
    132: [
        function(e, t, n) {
            "use strict";
            var o = e("./_string-at")(!0);
            e("./_iter-define")(String, "String", function(e) {
                this._t = String(e), this._i = 0;
            }, function() {
                var e = this._t, t = this._i;
                return t >= e.length ? {
                    value: void 0,
                    done: !0
                } : (t = o(e, t), this._i += t.length, {
                    value: t,
                    done: !1
                });
            });
        },
        {
            "./_iter-define": 59,
            "./_string-at": 95
        }
    ],
    133: [
        function(e, t, n) {
            "use strict";
            function o(e) {
                var t = H[e] = O(R[q]);
                return t._k = e, t;
            }
            function r(e, t) {
                x(e);
                for(var n, o = y(t = S(t)), r = 0, i = o.length; r < i;)$(e, n = o[r++], t[n]);
                return e;
            }
            function i(e) {
                var t = W.call(this, e = E(e, !0));
                return !(this === K && c(H, e) && !c(V, e)) && (!(t || !c(this, e) || !c(H, e) || c(this, z) && this[z][e]) || t);
            }
            function s(e, t) {
                if (e = S(e), t = E(t, !0), e !== K || !c(H, t) || c(V, t)) {
                    var n = L(e, t);
                    return !n || !c(H, t) || c(e, z) && e[z][t] || (n.enumerable = !0), n;
                }
            }
            var a = e("./_global"), c = e("./_has"), u = e("./_descriptors"), l = e("./_export"), f = e("./_redefine"), d = e("./_meta").KEY, p = e("./_fails"), h = e("./_shared"), _ = e("./_set-to-string-tag"), g = e("./_uid"), b = e("./_wks"), m = e("./_wks-ext"), v = e("./_wks-define"), y = e("./_enum-keys"), j = e("./_is-array"), x = e("./_an-object"), w = e("./_is-object"), k = e("./_to-object"), S = e("./_to-iobject"), E = e("./_to-primitive"), P = e("./_property-desc"), O = e("./_object-create"), A = e("./_object-gopn-ext"), M = e("./_object-gopd"), D = e("./_object-gops"), T = e("./_object-dp"), C = e("./_object-keys"), L = M.f, I = T.f, F = A.f, R = a.Symbol, B = a.JSON, U = B && B.stringify, q = "prototype", z = b("_hidden"), N = b("toPrimitive"), W = {}.propertyIsEnumerable, G = h("symbol-registry"), H = h("symbols"), V = h("op-symbols"), K = Object[q], X = "function" == typeof R && !!D.f, Y = a.QObject, Q = !Y || !Y[q] || !Y[q].findChild, J = u && p(function() {
                return 7 != O(I({}, "a", {
                    get: function() {
                        return I(this, "a", {
                            value: 7
                        }).a;
                    }
                })).a;
            }) ? function(e, t, n) {
                var o = L(K, t);
                o && delete K[t], I(e, t, n), o && e !== K && I(K, t, o);
            } : I, Z = X && "symbol" == typeof R.iterator ? function(e) {
                return "symbol" == typeof e;
            } : function(e) {
                return e instanceof R;
            }, $ = function(e, t, n) {
                return e === K && $(V, t, n), x(e), t = E(t, !0), x(n), c(H, t) ? (n.enumerable ? (c(e, z) && e[z][t] && (e[z][t] = !1), n = O(n, {
                    enumerable: P(0, !1)
                })) : (c(e, z) || I(e, z, P(1, {})), e[z][t] = !0), J(e, t, n)) : I(e, t, n);
            }, h = function(e) {
                for(var t, n = F(S(e)), o = [], r = 0; n.length > r;)c(H, t = n[r++]) || t == z || t == d || o.push(t);
                return o;
            }, Y = function(e) {
                for(var t, n = e === K, o = F(n ? V : S(e)), r = [], i = 0; o.length > i;)!c(H, t = o[i++]) || n && !c(K, t) || r.push(H[t]);
                return r;
            };
            X || (f((R = function() {
                if (this instanceof R) throw TypeError("Symbol is not a constructor!");
                var t = g(0 < arguments.length ? arguments[0] : void 0), n = function(e) {
                    this === K && n.call(V, e), c(this, z) && c(this[z], t) && (this[z][t] = !1), J(this, t, P(1, e));
                };
                return u && Q && J(K, t, {
                    configurable: !0,
                    set: n
                }), o(t);
            })[q], "toString", function() {
                return this._k;
            }), M.f = s, T.f = $, e("./_object-gopn").f = A.f = h, e("./_object-pie").f = i, D.f = Y, u && !e("./_library") && f(K, "propertyIsEnumerable", i, !0), m.f = function(e) {
                return o(b(e));
            }), l(l.G + l.W + l.F * !X, {
                Symbol: R
            });
            for(var ee = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), te = 0; ee.length > te;)b(ee[te++]);
            for(var ne = C(b.store), oe = 0; ne.length > oe;)v(ne[oe++]);
            l(l.S + l.F * !X, "Symbol", {
                for: function(e) {
                    return c(G, e += "") ? G[e] : G[e] = R(e);
                },
                keyFor: function(e) {
                    if (!Z(e)) throw TypeError(e + " is not a symbol!");
                    for(var t in G)if (G[t] === e) return t;
                },
                useSetter: function() {
                    Q = !0;
                },
                useSimple: function() {
                    Q = !1;
                }
            }), l(l.S + l.F * !X, "Object", {
                create: function(e, t) {
                    return void 0 === t ? O(e) : r(O(e), t);
                },
                defineProperty: $,
                defineProperties: r,
                getOwnPropertyDescriptor: s,
                getOwnPropertyNames: h,
                getOwnPropertySymbols: Y
            });
            Y = p(function() {
                D.f(1);
            });
            l(l.S + l.F * Y, "Object", {
                getOwnPropertySymbols: function(e) {
                    return D.f(k(e));
                }
            }), B && l(l.S + l.F * (!X || p(function() {
                var e = R();
                return "[null]" != U([
                    e
                ]) || "{}" != U({
                    a: e
                }) || "{}" != U(Object(e));
            })), "JSON", {
                stringify: function(e) {
                    for(var t, n, o = [
                        e
                    ], r = 1; r < arguments.length;)o.push(arguments[r++]);
                    if (n = t = o[1], (w(t) || void 0 !== e) && !Z(e)) return j(t) || (t = function(e, t) {
                        if ("function" == typeof n && (t = n.call(this, e, t)), !Z(t)) return t;
                    }), o[1] = t, U.apply(B, o);
                }
            }), R[q][N] || e("./_hide")(R[q], N, R[q].valueOf), _(R, "Symbol"), _(Math, "Math", !0), _(a.JSON, "JSON", !0);
        },
        {
            "./_an-object": 22,
            "./_descriptors": 34,
            "./_enum-keys": 37,
            "./_export": 38,
            "./_fails": 40,
            "./_global": 45,
            "./_has": 46,
            "./_hide": 47,
            "./_is-array": 54,
            "./_is-object": 55,
            "./_library": 63,
            "./_meta": 66,
            "./_object-create": 70,
            "./_object-dp": 71,
            "./_object-gopd": 73,
            "./_object-gopn": 75,
            "./_object-gopn-ext": 74,
            "./_object-gops": 76,
            "./_object-keys": 79,
            "./_object-pie": 80,
            "./_property-desc": 84,
            "./_redefine": 86,
            "./_set-to-string-tag": 91,
            "./_shared": 93,
            "./_to-iobject": 101,
            "./_to-object": 103,
            "./_to-primitive": 104,
            "./_uid": 108,
            "./_wks": 112,
            "./_wks-define": 110,
            "./_wks-ext": 111
        }
    ],
    134: [
        function(e, t, n) {
            e("./_typed-array")("Uint8", 1, function(o) {
                return function(e, t, n) {
                    return o(this, e, t, n);
                };
            });
        },
        {
            "./_typed-array": 105
        }
    ],
    135: [
        function(e, t, n) {
            for(var o = e("./es6.array.iterator"), r = e("./_object-keys"), i = e("./_redefine"), s = e("./_global"), a = e("./_hide"), c = e("./_iterators"), e = e("./_wks"), u = e("iterator"), l = e("toStringTag"), f = c.Array, d = {
                CSSRuleList: !0,
                CSSStyleDeclaration: !1,
                CSSValueList: !1,
                ClientRectList: !1,
                DOMRectList: !1,
                DOMStringList: !1,
                DOMTokenList: !0,
                DataTransferItemList: !1,
                FileList: !1,
                HTMLAllCollection: !1,
                HTMLCollection: !1,
                HTMLFormElement: !1,
                HTMLSelectElement: !1,
                MediaList: !0,
                MimeTypeArray: !1,
                NamedNodeMap: !1,
                NodeList: !0,
                PaintRequestList: !1,
                Plugin: !1,
                PluginArray: !1,
                SVGLengthList: !1,
                SVGNumberList: !1,
                SVGPathSegList: !1,
                SVGPointList: !1,
                SVGStringList: !1,
                SVGTransformList: !1,
                SourceBufferList: !1,
                StyleSheetList: !0,
                TextTrackCueList: !1,
                TextTrackList: !1,
                TouchList: !1
            }, p = r(d), h = 0; h < p.length; h++){
                var _, g = p[h], b = d[g], m = s[g], v = m && m.prototype;
                if (v && (v[u] || a(v, u, f), v[l] || a(v, l, g), c[g] = f, b)) for(_ in o)v[_] || i(v, _, o[_], !0);
            }
        },
        {
            "./_global": 45,
            "./_hide": 47,
            "./_iterators": 62,
            "./_object-keys": 79,
            "./_redefine": 86,
            "./_wks": 112,
            "./es6.array.iterator": 115
        }
    ]
}, {}, [
    17
]); //# sourceMappingURL=js-dos.js.map

//# sourceMappingURL=dos-zone.9e072fb9.js.map
